/* Chartist.js 0.9.4
 * Copyright © 2015 Gion Kunz
 * Free to use under the WTFPL license.
 * http://www.wtfpl.net/
 */

!function(a,b){"function"==typeof define&&define.amd?define([],function(){return a.Chartist=b()}):"object"==typeof exports?module.exports=b():a.Chartist=b()}(this,function(){var a={version:"0.9.4"};return function(a,b,c){"use strict";c.noop=function(a){return a},c.alphaNumerate=function(a){return String.fromCharCode(97+a%26)},c.extend=function(a){a=a||{};var b=Array.prototype.slice.call(arguments,1);return b.forEach(function(b){for(var d in b)"object"!=typeof b[d]||null===b[d]||b[d]instanceof Array?a[d]=b[d]:a[d]=c.extend({},a[d],b[d])}),a},c.replaceAll=function(a,b,c){return a.replace(new RegExp(b,"g"),c)},c.stripUnit=function(a){return"string"==typeof a&&(a=a.replace(/[^0-9\+-\.]/g,"")),+a},c.ensureUnit=function(a,b){return"number"==typeof a&&(a+=b),a},c.querySelector=function(a){return a instanceof Node?a:b.querySelector(a)},c.times=function(a){return Array.apply(null,new Array(a))},c.sum=function(a,b){return a+(b?b:0)},c.mapMultiply=function(a){return function(b){return b*a}},c.mapAdd=function(a){return function(b){return b+a}},c.serialMap=function(a,b){var d=[],e=Math.max.apply(null,a.map(function(a){return a.length}));return c.times(e).forEach(function(c,e){var f=a.map(function(a){return a[e]});d[e]=b.apply(null,f)}),d},c.roundWithPrecision=function(a,b){var d=Math.pow(10,b||c.precision);return Math.round(a*d)/d},c.precision=8,c.escapingMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"},c.serialize=function(a){return null===a||void 0===a?a:("number"==typeof a?a=""+a:"object"==typeof a&&(a=JSON.stringify({data:a})),Object.keys(c.escapingMap).reduce(function(a,b){return c.replaceAll(a,b,c.escapingMap[b])},a))},c.deserialize=function(a){if("string"!=typeof a)return a;a=Object.keys(c.escapingMap).reduce(function(a,b){return c.replaceAll(a,c.escapingMap[b],b)},a);try{a=JSON.parse(a),a=void 0!==a.data?a.data:a}catch(b){}return a},c.createSvg=function(a,b,d,e){var f;return b=b||"100%",d=d||"100%",Array.prototype.slice.call(a.querySelectorAll("svg")).filter(function(a){return a.getAttributeNS("http://www.w3.org/2000/xmlns/",c.xmlNs.prefix)}).forEach(function(b){a.removeChild(b)}),f=new c.Svg("svg").attr({width:b,height:d}).addClass(e).attr({style:"width: "+b+"; height: "+d+";"}),a.appendChild(f._node),f},c.reverseData=function(a){a.labels.reverse(),a.series.reverse();for(var b=0;b<a.series.length;b++)"object"==typeof a.series[b]&&void 0!==a.series[b].data?a.series[b].data.reverse():a.series[b]instanceof Array&&a.series[b].reverse()},c.getDataArray=function(a,b,d){function e(a){if(c.isFalseyButZero(a))return void 0;if((a.data||a)instanceof Array)return(a.data||a).map(e);if(a.hasOwnProperty("value"))return e(a.value);if(d){var b={};return"string"==typeof d?b[d]=c.getNumberOrUndefined(a):b.y=c.getNumberOrUndefined(a),b.x=a.hasOwnProperty("x")?c.getNumberOrUndefined(a.x):b.x,b.y=a.hasOwnProperty("y")?c.getNumberOrUndefined(a.y):b.y,b}return c.getNumberOrUndefined(a)}return(b&&!a.reversed||!b&&a.reversed)&&(c.reverseData(a),a.reversed=!a.reversed),a.series.map(e)},c.normalizePadding=function(a,b){return b=b||0,"number"==typeof a?{top:a,right:a,bottom:a,left:a}:{top:"number"==typeof a.top?a.top:b,right:"number"==typeof a.right?a.right:b,bottom:"number"==typeof a.bottom?a.bottom:b,left:"number"==typeof a.left?a.left:b}},c.getMetaData=function(a,b){var d=a.data?a.data[b]:a[b];return d?c.serialize(d.meta):void 0},c.orderOfMagnitude=function(a){return Math.floor(Math.log(Math.abs(a))/Math.LN10)},c.projectLength=function(a,b,c){return b/c.range*a},c.getAvailableHeight=function(a,b){return Math.max((c.stripUnit(b.height)||a.height())-(b.chartPadding.top+b.chartPadding.bottom)-b.axisX.offset,0)},c.getHighLow=function(a,b,d){function e(a){if(void 0===a)return void 0;if(a instanceof Array)for(var b=0;b<a.length;b++)e(a[b]);else{var c=d?+a[d]:+a;g&&c>f.high&&(f.high=c),h&&c<f.low&&(f.low=c)}}b=c.extend({},b,d?b["axis"+d.toUpperCase()]:{});var f={high:void 0===b.high?-Number.MAX_VALUE:+b.high,low:void 0===b.low?Number.MAX_VALUE:+b.low},g=void 0===b.high,h=void 0===b.low;return(g||h)&&e(a),(b.referenceValue||0===b.referenceValue)&&(f.high=Math.max(b.referenceValue,f.high),f.low=Math.min(b.referenceValue,f.low)),f.high<=f.low&&(0===f.low?f.high=1:f.low<0?f.high=0:f.low=0),f},c.isNum=function(a){return!isNaN(a)&&isFinite(a)},c.isFalseyButZero=function(a){return!a&&0!==a},c.getNumberOrUndefined=function(a){return isNaN(+a)?void 0:+a},c.getMultiValue=function(a,b){return c.isNum(a)?+a:a?a[b||"y"]||0:0},c.rho=function(a){function b(a,c){return a%c===0?c:b(c,a%c)}function c(a){return a*a+1}if(1===a)return a;var d,e=2,f=2;if(a%2===0)return 2;do e=c(e)%a,f=c(c(f))%a,d=b(Math.abs(e-f),a);while(1===d);return d},c.getBounds=function(a,b,d,e){var f,g,h,i=0,j={high:b.high,low:b.low};j.valueRange=j.high-j.low,j.oom=c.orderOfMagnitude(j.valueRange),j.step=Math.pow(10,j.oom),j.min=Math.floor(j.low/j.step)*j.step,j.max=Math.ceil(j.high/j.step)*j.step,j.range=j.max-j.min,j.numberOfSteps=Math.round(j.range/j.step);var k=c.projectLength(a,j.step,j),l=d>k,m=e?c.rho(j.range):0;if(e&&c.projectLength(a,1,j)>=d)j.step=1;else if(e&&m<j.step&&c.projectLength(a,m,j)>=d)j.step=m;else for(;;){if(l&&c.projectLength(a,j.step,j)<=d)j.step*=2;else{if(l||!(c.projectLength(a,j.step/2,j)>=d))break;if(j.step/=2,e&&j.step%1!==0){j.step*=2;break}}if(i++>1e3)throw new Error("Exceeded maximum number of iterations while optimizing scale step!")}for(g=j.min,h=j.max;g+j.step<=j.low;)g+=j.step;for(;h-j.step>=j.high;)h-=j.step;for(j.min=g,j.max=h,j.range=j.max-j.min,j.values=[],f=j.min;f<=j.max;f+=j.step)j.values.push(c.roundWithPrecision(f));return j},c.polarToCartesian=function(a,b,c,d){var e=(d-90)*Math.PI/180;return{x:a+c*Math.cos(e),y:b+c*Math.sin(e)}},c.createChartRect=function(a,b,d){var e=!(!b.axisX&&!b.axisY),f=e?b.axisY.offset:0,g=e?b.axisX.offset:0,h=a.width()||c.stripUnit(b.width)||0,i=a.height()||c.stripUnit(b.height)||0,j=c.normalizePadding(b.chartPadding,d);h=Math.max(h,f+j.left+j.right),i=Math.max(i,g+j.top+j.bottom);var k={padding:j,width:function(){return this.x2-this.x1},height:function(){return this.y1-this.y2}};return e?("start"===b.axisX.position?(k.y2=j.top+g,k.y1=Math.max(i-j.bottom,k.y2+1)):(k.y2=j.top,k.y1=Math.max(i-j.bottom-g,k.y2+1)),"start"===b.axisY.position?(k.x1=j.left+f,k.x2=Math.max(h-j.right,k.x1+1)):(k.x1=j.left,k.x2=Math.max(h-j.right-f,k.x1+1))):(k.x1=j.left,k.x2=Math.max(h-j.right,k.x1+1),k.y2=j.top,k.y1=Math.max(i-j.bottom,k.y2+1)),k},c.createGrid=function(a,b,d,e,f,g,h,i){var j={};j[d.units.pos+"1"]=a,j[d.units.pos+"2"]=a,j[d.counterUnits.pos+"1"]=e,j[d.counterUnits.pos+"2"]=e+f;var k=g.elem("line",j,h.join(" "));i.emit("draw",c.extend({type:"grid",axis:d,index:b,group:g,element:k},j))},c.createLabel=function(a,b,d,e,f,g,h,i,j,k,l){var m,n={};if(n[f.units.pos]=a+h[f.units.pos],n[f.counterUnits.pos]=h[f.counterUnits.pos],n[f.units.len]=b,n[f.counterUnits.len]=g-10,k){var o='<span class="'+j.join(" ")+'" style="'+f.units.len+": "+Math.round(n[f.units.len])+"px; "+f.counterUnits.len+": "+Math.round(n[f.counterUnits.len])+'px">'+e[d]+"</span>";m=i.foreignObject(o,c.extend({style:"overflow: visible;"},n))}else m=i.elem("text",n,j.join(" ")).text(e[d]);l.emit("draw",c.extend({type:"label",axis:f,index:d,group:i,element:m,text:e[d]},n))},c.getSeriesOption=function(a,b,c){if(a.name&&b.series&&b.series[a.name]){var d=b.series[a.name];return d.hasOwnProperty(c)?d[c]:b[c]}return b[c]},c.optionsProvider=function(b,d,e){function f(b){var f=h;if(h=c.extend({},j),d)for(i=0;i<d.length;i++){var g=a.matchMedia(d[i][0]);g.matches&&(h=c.extend(h,d[i][1]))}e&&!b&&e.emit("optionsChanged",{previousOptions:f,currentOptions:h})}function g(){k.forEach(function(a){a.removeListener(f)})}var h,i,j=c.extend({},b),k=[];if(!a.matchMedia)throw"window.matchMedia not found! Make sure you're using a polyfill.";if(d)for(i=0;i<d.length;i++){var l=a.matchMedia(d[i][0]);l.addListener(f),k.push(l)}return f(!0),{removeMediaQueryListeners:g,getCurrentOptions:function(){return c.extend({},h)}}}}(window,document,a),function(a,b,c){"use strict";c.Interpolation={},c.Interpolation.none=function(){return function(a,b){for(var d=new c.Svg.Path,e=!0,f=1;f<a.length;f+=2){var g=b[(f-1)/2];void 0===g.value?e=!0:e?(d.move(a[f-1],a[f],!1,g),e=!1):d.line(a[f-1],a[f],!1,g)}return d}},c.Interpolation.simple=function(a){var b={divisor:2};a=c.extend({},b,a);var d=1/Math.max(1,a.divisor);return function(a,b){for(var e=new c.Svg.Path,f=!0,g=2;g<a.length;g+=2){var h=a[g-2],i=a[g-1],j=a[g],k=a[g+1],l=(j-h)*d,m=b[g/2-1],n=b[g/2];void 0===m.value?f=!0:(f&&e.move(h,i,!1,m),void 0!==n.value&&(e.curve(h+l,i,j-l,k,j,k,!1,n),f=!1))}return e}},c.Interpolation.cardinal=function(a){function b(a,b){for(var c=[],d=!0,e=0;e<a.length;e+=2)void 0===b[e/2].value?d=!0:(d&&(c.push({pathCoordinates:[],valueData:[]}),d=!1),c[c.length-1].pathCoordinates.push(a[e],a[e+1]),c[c.length-1].valueData.push(b[e/2]));return c}var d={tension:1};a=c.extend({},d,a);var e=Math.min(1,Math.max(0,a.tension)),f=1-e;return function g(a,d){var h=b(a,d);if(h.length>1){var i=[];return h.forEach(function(a){i.push(g(a.pathCoordinates,a.valueData))}),c.Svg.Path.join(i)}if(a=h[0].pathCoordinates,d=h[0].valueData,a.length<=4)return c.Interpolation.none()(a,d);for(var j,k=(new c.Svg.Path).move(a[0],a[1],!1,d[0]),l=0,m=a.length;m-2*!j>l;l+=2){var n=[{x:+a[l-2],y:+a[l-1]},{x:+a[l],y:+a[l+1]},{x:+a[l+2],y:+a[l+3]},{x:+a[l+4],y:+a[l+5]}];j?l?m-4===l?n[3]={x:+a[0],y:+a[1]}:m-2===l&&(n[2]={x:+a[0],y:+a[1]},n[3]={x:+a[2],y:+a[3]}):n[0]={x:+a[m-2],y:+a[m-1]}:m-4===l?n[3]=n[2]:l||(n[0]={x:+a[l],y:+a[l+1]}),k.curve(e*(-n[0].x+6*n[1].x+n[2].x)/6+f*n[2].x,e*(-n[0].y+6*n[1].y+n[2].y)/6+f*n[2].y,e*(n[1].x+6*n[2].x-n[3].x)/6+f*n[2].x,e*(n[1].y+6*n[2].y-n[3].y)/6+f*n[2].y,n[2].x,n[2].y,!1,d[(l+2)/2])}return k}},c.Interpolation.step=function(a){var b={postpone:!0};return a=c.extend({},b,a),function(b,d){for(var e=new c.Svg.Path,f=!0,g=2;g<b.length;g+=2){var h=b[g-2],i=b[g-1],j=b[g],k=b[g+1],l=d[g/2-1],m=d[g/2];void 0===l.value?f=!0:(f&&e.move(h,i,!1,l),void 0!==m.value&&(a.postpone?e.line(j,i,!1,l):e.line(h,k,!1,m),e.line(j,k,!1,m),f=!1))}return e}}}(window,document,a),function(a,b,c){"use strict";c.EventEmitter=function(){function a(a,b){d[a]=d[a]||[],d[a].push(b)}function b(a,b){d[a]&&(b?(d[a].splice(d[a].indexOf(b),1),0===d[a].length&&delete d[a]):delete d[a])}function c(a,b){d[a]&&d[a].forEach(function(a){a(b)}),d["*"]&&d["*"].forEach(function(c){c(a,b)})}var d=[];return{addEventHandler:a,removeEventHandler:b,emit:c}}}(window,document,a),function(a,b,c){"use strict";function d(a){var b=[];if(a.length)for(var c=0;c<a.length;c++)b.push(a[c]);return b}function e(a,b){var d=b||this.prototype||c.Class,e=Object.create(d);c.Class.cloneDefinitions(e,a);var f=function(){var a,b=e.constructor||function(){};return a=this===c?Object.create(e):this,b.apply(a,Array.prototype.slice.call(arguments,0)),a};return f.prototype=e,f["super"]=d,f.extend=this.extend,f}function f(){var a=d(arguments),b=a[0];return a.splice(1,a.length-1).forEach(function(a){Object.getOwnPropertyNames(a).forEach(function(c){delete b[c],Object.defineProperty(b,c,Object.getOwnPropertyDescriptor(a,c))})}),b}c.Class={extend:e,cloneDefinitions:f}}(window,document,a),function(a,b,c){"use strict";function d(a,b,d){return a&&(this.data=a,this.eventEmitter.emit("data",{type:"update",data:this.data})),b&&(this.options=c.extend({},d?this.options:this.defaultOptions,b),this.initializeTimeoutId||(this.optionsProvider.removeMediaQueryListeners(),this.optionsProvider=c.optionsProvider(this.options,this.responsiveOptions,this.eventEmitter))),this.initializeTimeoutId||this.createChart(this.optionsProvider.getCurrentOptions()),this}function e(){return this.initializeTimeoutId?a.clearTimeout(this.initializeTimeoutId):(a.removeEventListener("resize",this.resizeListener),this.optionsProvider.removeMediaQueryListeners()),this}function f(a,b){return this.eventEmitter.addEventHandler(a,b),this}function g(a,b){return this.eventEmitter.removeEventHandler(a,b),this}function h(){a.addEventListener("resize",this.resizeListener),this.optionsProvider=c.optionsProvider(this.options,this.responsiveOptions,this.eventEmitter),this.eventEmitter.addEventHandler("optionsChanged",function(){this.update()}.bind(this)),this.options.plugins&&this.options.plugins.forEach(function(a){a instanceof Array?a[0](this,a[1]):a(this)}.bind(this)),this.eventEmitter.emit("data",{type:"initial",data:this.data}),this.createChart(this.optionsProvider.getCurrentOptions()),this.initializeTimeoutId=void 0}function i(a,b,d,e,f){this.container=c.querySelector(a),this.data=b,this.defaultOptions=d,this.options=e,this.responsiveOptions=f,this.eventEmitter=c.EventEmitter(),this.supportsForeignObject=c.Svg.isSupported("Extensibility"),this.supportsAnimations=c.Svg.isSupported("AnimationEventsAttribute"),this.resizeListener=function(){this.update()}.bind(this),this.container&&(this.container.__chartist__&&this.container.__chartist__.detach(),this.container.__chartist__=this),this.initializeTimeoutId=setTimeout(h.bind(this),0)}c.Base=c.Class.extend({constructor:i,optionsProvider:void 0,container:void 0,svg:void 0,eventEmitter:void 0,createChart:function(){throw new Error("Base chart type can't be instantiated!")},update:d,detach:e,on:f,off:g,version:c.version,supportsForeignObject:!1})}(window,document,a),function(a,b,c){"use strict";function d(a,d,e,f,g){a instanceof Element?this._node=a:(this._node=b.createElementNS(z,a),"svg"===a&&this._node.setAttributeNS(A,c.xmlNs.qualifiedName,c.xmlNs.uri)),d&&this.attr(d),e&&this.addClass(e),f&&(g&&f._node.firstChild?f._node.insertBefore(this._node,f._node.firstChild):f._node.appendChild(this._node))}function e(a,b){return"string"==typeof a?b?this._node.getAttributeNS(b,a):this._node.getAttribute(a):(Object.keys(a).forEach(function(d){void 0!==a[d]&&(b?this._node.setAttributeNS(b,[c.xmlNs.prefix,":",d].join(""),a[d]):this._node.setAttribute(d,a[d]))}.bind(this)),this)}function f(a,b,d,e){return new c.Svg(a,b,d,this,e)}function g(){return this._node.parentNode instanceof SVGElement?new c.Svg(this._node.parentNode):null}function h(){for(var a=this._node;"svg"!==a.nodeName;)a=a.parentNode;return new c.Svg(a)}function i(a){var b=this._node.querySelector(a);return b?new c.Svg(b):null}function j(a){var b=this._node.querySelectorAll(a);return b.length?new c.Svg.List(b):null}function k(a,c,d,e){if("string"==typeof a){var f=b.createElement("div");f.innerHTML=a,a=f.firstChild}a.setAttribute("xmlns",B);var g=this.elem("foreignObject",c,d,e);return g._node.appendChild(a),g}function l(a){return this._node.appendChild(b.createTextNode(a)),this}function m(){for(;this._node.firstChild;)this._node.removeChild(this._node.firstChild);return this}function n(){return this._node.parentNode.removeChild(this._node),this.parent()}function o(a){return this._node.parentNode.replaceChild(a._node,this._node),a}function p(a,b){return b&&this._node.firstChild?this._node.insertBefore(a._node,this._node.firstChild):this._node.appendChild(a._node),this}function q(){return this._node.getAttribute("class")?this._node.getAttribute("class").trim().split(/\s+/):[]}function r(a){return this._node.setAttribute("class",this.classes(this._node).concat(a.trim().split(/\s+/)).filter(function(a,b,c){return c.indexOf(a)===b}).join(" ")),this}function s(a){var b=a.trim().split(/\s+/);return this._node.setAttribute("class",this.classes(this._node).filter(function(a){return-1===b.indexOf(a)}).join(" ")),this}function t(){return this._node.setAttribute("class",""),this}function u(a,b){try{return a.getBBox()[b]}catch(c){}return 0}function v(){return this._node.clientHeight||Math.round(u(this._node,"height"))||this._node.parentNode.clientHeight}function w(){return this._node.clientWidth||Math.round(u(this._node,"width"))||this._node.parentNode.clientWidth}function x(a,b,d){return void 0===b&&(b=!0),Object.keys(a).forEach(function(e){function f(a,b){var f,g,h,i={};a.easing&&(h=a.easing instanceof Array?a.easing:c.Svg.Easing[a.easing],delete a.easing),a.begin=c.ensureUnit(a.begin,"ms"),a.dur=c.ensureUnit(a.dur,"ms"),h&&(a.calcMode="spline",a.keySplines=h.join(" "),a.keyTimes="0;1"),b&&(a.fill="freeze",i[e]=a.from,this.attr(i),g=c.stripUnit(a.begin||0),a.begin="indefinite"),f=this.elem("animate",c.extend({attributeName:e},a)),b&&setTimeout(function(){try{f._node.beginElement()}catch(b){i[e]=a.to,this.attr(i),f.remove()}}.bind(this),g),d&&f._node.addEventListener("beginEvent",function(){d.emit("animationBegin",{element:this,animate:f._node,params:a})}.bind(this)),f._node.addEventListener("endEvent",function(){d&&d.emit("animationEnd",{element:this,animate:f._node,params:a}),b&&(i[e]=a.to,this.attr(i),f.remove())}.bind(this))}a[e]instanceof Array?a[e].forEach(function(a){f.bind(this)(a,!1)}.bind(this)):f.bind(this)(a[e],b)}.bind(this)),this}function y(a){var b=this;this.svgElements=[];for(var d=0;d<a.length;d++)this.svgElements.push(new c.Svg(a[d]));Object.keys(c.Svg.prototype).filter(function(a){return-1===["constructor","parent","querySelector","querySelectorAll","replace","append","classes","height","width"].indexOf(a)}).forEach(function(a){b[a]=function(){var d=Array.prototype.slice.call(arguments,0);return b.svgElements.forEach(function(b){c.Svg.prototype[a].apply(b,d)}),b}})}var z="http://www.w3.org/2000/svg",A="http://www.w3.org/2000/xmlns/",B="http://www.w3.org/1999/xhtml";c.xmlNs={qualifiedName:"xmlns:ct",prefix:"ct",uri:"http://gionkunz.github.com/chartist-js/ct"},c.Svg=c.Class.extend({constructor:d,attr:e,elem:f,parent:g,root:h,querySelector:i,querySelectorAll:j,foreignObject:k,text:l,empty:m,remove:n,replace:o,append:p,classes:q,addClass:r,removeClass:s,removeAllClasses:t,height:v,width:w,animate:x}),c.Svg.isSupported=function(a){return b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#"+a,"1.1")};var C={easeInSine:[.47,0,.745,.715],easeOutSine:[.39,.575,.565,1],easeInOutSine:[.445,.05,.55,.95],easeInQuad:[.55,.085,.68,.53],easeOutQuad:[.25,.46,.45,.94],easeInOutQuad:[.455,.03,.515,.955],easeInCubic:[.55,.055,.675,.19],easeOutCubic:[.215,.61,.355,1],easeInOutCubic:[.645,.045,.355,1],easeInQuart:[.895,.03,.685,.22],easeOutQuart:[.165,.84,.44,1],easeInOutQuart:[.77,0,.175,1],easeInQuint:[.755,.05,.855,.06],easeOutQuint:[.23,1,.32,1],easeInOutQuint:[.86,0,.07,1],easeInExpo:[.95,.05,.795,.035],easeOutExpo:[.19,1,.22,1],easeInOutExpo:[1,0,0,1],easeInCirc:[.6,.04,.98,.335],easeOutCirc:[.075,.82,.165,1],easeInOutCirc:[.785,.135,.15,.86],easeInBack:[.6,-.28,.735,.045],easeOutBack:[.175,.885,.32,1.275],easeInOutBack:[.68,-.55,.265,1.55]};c.Svg.Easing=C,c.Svg.List=c.Class.extend({constructor:y})}(window,document,a),function(a,b,c){"use strict";function d(a,b,d,e,f,g){var h=c.extend({command:f?a.toLowerCase():a.toUpperCase()},b,g?{data:g}:{});d.splice(e,0,h)}function e(a,b){a.forEach(function(c,d){u[c.command.toLowerCase()].forEach(function(e,f){b(c,e,d,f,a)})})}function f(a,b){this.pathElements=[],this.pos=0,this.close=a,this.options=c.extend({},v,b)}function g(a){return void 0!==a?(this.pos=Math.max(0,Math.min(this.pathElements.length,a)),this):this.pos}function h(a){return this.pathElements.splice(this.pos,a),this}function i(a,b,c,e){return d("M",{x:+a,y:+b},this.pathElements,this.pos++,c,e),this}function j(a,b,c,e){return d("L",{x:+a,y:+b},this.pathElements,this.pos++,c,e),this}function k(a,b,c,e,f,g,h,i){return d("C",{x1:+a,y1:+b,x2:+c,y2:+e,x:+f,y:+g},this.pathElements,this.pos++,h,i),this}function l(a,b,c,e,f,g,h,i,j){return d("A",{rx:+a,ry:+b,xAr:+c,lAf:+e,sf:+f,x:+g,y:+h},this.pathElements,this.pos++,i,j),this}function m(a){var b=a.replace(/([A-Za-z])([0-9])/g,"$1 $2").replace(/([0-9])([A-Za-z])/g,"$1 $2").split(/[\s,]+/).reduce(function(a,b){return b.match(/[A-Za-z]/)&&a.push([]),a[a.length-1].push(b),a},[]);"Z"===b[b.length-1][0].toUpperCase()&&b.pop();var d=b.map(function(a){var b=a.shift(),d=u[b.toLowerCase()];return c.extend({command:b},d.reduce(function(b,c,d){return b[c]=+a[d],b},{}))}),e=[this.pos,0];return Array.prototype.push.apply(e,d),Array.prototype.splice.apply(this.pathElements,e),this.pos+=d.length,this}function n(){var a=Math.pow(10,this.options.accuracy);return this.pathElements.reduce(function(b,c){var d=u[c.command.toLowerCase()].map(function(b){return this.options.accuracy?Math.round(c[b]*a)/a:c[b]}.bind(this));return b+c.command+d.join(",")}.bind(this),"")+(this.close?"Z":"")}function o(a,b){return e(this.pathElements,function(c,d){c[d]*="x"===d[0]?a:b}),this}function p(a,b){return e(this.pathElements,function(c,d){c[d]+="x"===d[0]?a:b}),this}function q(a){return e(this.pathElements,function(b,c,d,e,f){var g=a(b,c,d,e,f);(g||0===g)&&(b[c]=g)}),this}function r(a){var b=new c.Svg.Path(a||this.close);return b.pos=this.pos,b.pathElements=this.pathElements.slice().map(function(a){return c.extend({},a)}),b.options=c.extend({},this.options),b}function s(a){var b=[new c.Svg.Path];return this.pathElements.forEach(function(d){d.command===a.toUpperCase()&&0!==b[b.length-1].pathElements.length&&b.push(new c.Svg.Path),b[b.length-1].pathElements.push(d)}),b}function t(a,b,d){for(var e=new c.Svg.Path(b,d),f=0;f<a.length;f++)for(var g=a[f],h=0;h<g.pathElements.length;h++)e.pathElements.push(g.pathElements[h]);return e}var u={m:["x","y"],l:["x","y"],c:["x1","y1","x2","y2","x","y"],a:["rx","ry","xAr","lAf","sf","x","y"]},v={accuracy:3};c.Svg.Path=c.Class.extend({constructor:f,position:g,remove:h,move:i,line:j,curve:k,arc:l,scale:o,translate:p,transform:q,parse:m,stringify:n,clone:r,splitByCommand:s}),c.Svg.Path.elementDescriptions=u,c.Svg.Path.join=t}(window,document,a),function(a,b,c){"use strict";function d(a,b,c,d){this.units=a,this.counterUnits=a===f.x?f.y:f.x,this.chartRect=b,this.axisLength=b[a.rectEnd]-b[a.rectStart],this.gridOffset=b[a.rectOffset],this.ticks=c,this.options=d}function e(a,b,d,e,f){var g=e["axis"+this.units.pos.toUpperCase()],h=this.ticks.map(this.projectValue.bind(this)),i=this.ticks.map(g.labelInterpolationFnc);h.forEach(function(j,k){var l,m={x:0,y:0};l=h[k+1]?h[k+1]-j:Math.max(this.axisLength-j,30),(i[k]||0===i[k])&&("x"===this.units.pos?(j=this.chartRect.x1+j,m.x=e.axisX.labelOffset.x,"start"===e.axisX.position?m.y=this.chartRect.padding.top+e.axisX.labelOffset.y+(d?5:20):m.y=this.chartRect.y1+e.axisX.labelOffset.y+(d?5:20)):(j=this.chartRect.y1-j,m.y=e.axisY.labelOffset.y-(d?l:0),"start"===e.axisY.position?m.x=d?this.chartRect.padding.left+e.axisY.labelOffset.x:this.chartRect.x1-10:m.x=this.chartRect.x2+e.axisY.labelOffset.x+10),g.showGrid&&c.createGrid(j,k,this,this.gridOffset,this.chartRect[this.counterUnits.len](),a,[e.classNames.grid,e.classNames[this.units.dir]],f),g.showLabel&&c.createLabel(j,l,k,i,this,g.offset,m,b,[e.classNames.label,e.classNames[this.units.dir],e.classNames[g.position]],d,f))}.bind(this))}var f={x:{pos:"x",len:"width",dir:"horizontal",rectStart:"x1",rectEnd:"x2",rectOffset:"y2"},y:{pos:"y",len:"height",dir:"vertical",rectStart:"y2",rectEnd:"y1",rectOffset:"x1"}};c.Axis=c.Class.extend({constructor:d,createGridAndLabels:e,projectValue:function(a,b,c){throw new Error("Base axis can't be instantiated!")}}),c.Axis.units=f}(window,document,a),function(a,b,c){"use strict";function d(a,b,d,e){var f=e.highLow||c.getHighLow(b.normalized,e,a.pos);this.bounds=c.getBounds(d[a.rectEnd]-d[a.rectStart],f,e.scaleMinSpace||20,e.onlyInteger),this.range={min:this.bounds.min,max:this.bounds.max},c.AutoScaleAxis["super"].constructor.call(this,a,d,this.bounds.values,e)}function e(a){return this.axisLength*(+c.getMultiValue(a,this.units.pos)-this.bounds.min)/this.bounds.range}c.AutoScaleAxis=c.Axis.extend({constructor:d,projectValue:e})}(window,document,a),function(a,b,c){"use strict";function d(a,b,d,e){var f=e.highLow||c.getHighLow(b.normalized,e,a.pos);this.divisor=e.divisor||1,this.ticks=e.ticks||c.times(this.divisor).map(function(a,b){return f.low+(f.high-f.low)/this.divisor*b}.bind(this)),this.range={min:f.low,max:f.high},c.FixedScaleAxis["super"].constructor.call(this,a,d,this.ticks,e),this.stepLength=this.axisLength/this.divisor}function e(a){return this.axisLength*(+c.getMultiValue(a,this.units.pos)-this.range.min)/(this.range.max-this.range.min)}c.FixedScaleAxis=c.Axis.extend({constructor:d,projectValue:e})}(window,document,a),function(a,b,c){"use strict";function d(a,b,d,e){c.StepAxis["super"].constructor.call(this,a,d,e.ticks,e),this.stepLength=this.axisLength/(e.ticks.length-(e.stretch?1:0))}function e(a,b){return this.stepLength*b}c.StepAxis=c.Axis.extend({constructor:d,projectValue:e})}(window,document,a),function(a,b,c){"use strict";function d(a){var b={raw:this.data,normalized:c.getDataArray(this.data,a.reverseData,!0)};this.svg=c.createSvg(this.container,a.width,a.height,a.classNames.chart);var d,e,g=this.svg.elem("g").addClass(a.classNames.gridGroup),h=this.svg.elem("g"),i=this.svg.elem("g").addClass(a.classNames.labelGroup),j=c.createChartRect(this.svg,a,f.padding);d=void 0===a.axisX.type?new c.StepAxis(c.Axis.units.x,b,j,c.extend({},a.axisX,{ticks:b.raw.labels,stretch:a.fullWidth})):a.axisX.type.call(c,c.Axis.units.x,b,j,a.axisX),e=void 0===a.axisY.type?new c.AutoScaleAxis(c.Axis.units.y,b,j,c.extend({},a.axisY,{high:c.isNum(a.high)?a.high:a.axisY.high,low:c.isNum(a.low)?a.low:a.axisY.low})):a.axisY.type.call(c,c.Axis.units.y,b,j,a.axisY),d.createGridAndLabels(g,i,this.supportsForeignObject,a,this.eventEmitter),e.createGridAndLabels(g,i,this.supportsForeignObject,a,this.eventEmitter),b.raw.series.forEach(function(f,g){var i=h.elem("g");i.attr({"series-name":f.name,meta:c.serialize(f.meta)},c.xmlNs.uri),i.addClass([a.classNames.series,f.className||a.classNames.series+"-"+c.alphaNumerate(g)].join(" "));var k=[],l=[];b.normalized[g].forEach(function(a,h){var i={x:j.x1+d.projectValue(a,h,b.normalized[g]),y:j.y1-e.projectValue(a,h,b.normalized[g])};k.push(i.x,i.y),l.push({value:a,valueIndex:h,meta:c.getMetaData(f,h)})}.bind(this));var m={lineSmooth:c.getSeriesOption(f,a,"lineSmooth"),showPoint:c.getSeriesOption(f,a,"showPoint"),showLine:c.getSeriesOption(f,a,"showLine"),showArea:c.getSeriesOption(f,a,"showArea"),areaBase:c.getSeriesOption(f,a,"areaBase")},n="function"==typeof m.lineSmooth?m.lineSmooth:m.lineSmooth?c.Interpolation.cardinal():c.Interpolation.none(),o=n(k,l);if(m.showPoint&&o.pathElements.forEach(function(b){var h=i.elem("line",{x1:b.x,y1:b.y,x2:b.x+.01,y2:b.y},a.classNames.point).attr({value:[b.data.value.x,b.data.value.y].filter(function(a){return a}).join(","),meta:b.data.meta},c.xmlNs.uri);this.eventEmitter.emit("draw",{type:"point",value:b.data.value,index:b.data.valueIndex,meta:b.data.meta,series:f,seriesIndex:g,axisX:d,axisY:e,group:i,element:h,x:b.x,y:b.y})}.bind(this)),m.showLine){var p=i.elem("path",{d:o.stringify()},a.classNames.line,!0);this.eventEmitter.emit("draw",{type:"line",values:b.normalized[g],path:o.clone(),chartRect:j,index:g,series:f,seriesIndex:g,axisX:d,axisY:e,group:i,element:p})}if(m.showArea&&e.range){var q=Math.max(Math.min(m.areaBase,e.range.max),e.range.min),r=j.y1-e.projectValue(q);o.splitByCommand("M").filter(function(a){return a.pathElements.length>1}).map(function(a){var b=a.pathElements[0],c=a.pathElements[a.pathElements.length-1];return a.clone(!0).position(0).remove(1).move(b.x,r).line(b.x,b.y).position(a.pathElements.length+1).line(c.x,r)}).forEach(function(h){var k=i.elem("path",{d:h.stringify()},a.classNames.area,!0).attr({values:b.normalized[g]},c.xmlNs.uri);this.eventEmitter.emit("draw",{type:"area",values:b.normalized[g],path:h.clone(),series:f,seriesIndex:g,axisX:d,axisY:e,chartRect:j,index:g,group:i,element:k})}.bind(this))}}.bind(this)),this.eventEmitter.emit("created",{bounds:e.bounds,chartRect:j,axisX:d,axisY:e,svg:this.svg,options:a})}function e(a,b,d,e){c.Line["super"].constructor.call(this,a,b,f,c.extend({},f,d),e)}var f={axisX:{offset:30,position:"end",labelOffset:{x:0,y:0},showLabel:!0,showGrid:!0,labelInterpolationFnc:c.noop,type:void 0},axisY:{offset:40,position:"start",labelOffset:{x:0,y:0},showLabel:!0,showGrid:!0,labelInterpolationFnc:c.noop,type:void 0,scaleMinSpace:20,onlyInteger:!1},width:void 0,height:void 0,showLine:!0,showPoint:!0,showArea:!1,areaBase:0,lineSmooth:!0,low:void 0,high:void 0,chartPadding:{top:15,right:15,bottom:5,left:10},fullWidth:!1,reverseData:!1,classNames:{chart:"ct-chart-line",label:"ct-label",labelGroup:"ct-labels",series:"ct-series",line:"ct-line",point:"ct-point",area:"ct-area",grid:"ct-grid",gridGroup:"ct-grids",vertical:"ct-vertical",horizontal:"ct-horizontal",start:"ct-start",end:"ct-end"}};c.Line=c.Base.extend({constructor:e,createChart:d})}(window,document,a),function(a,b,c){"use strict";function d(a){var b,d={raw:this.data,normalized:a.distributeSeries?c.getDataArray(this.data,a.reverseData,a.horizontalBars?"x":"y").map(function(a){return[a]}):c.getDataArray(this.data,a.reverseData,a.horizontalBars?"x":"y")};this.svg=c.createSvg(this.container,a.width,a.height,a.classNames.chart+(a.horizontalBars?" "+a.classNames.horizontalBars:""));var e=this.svg.elem("g").addClass(a.classNames.gridGroup),g=this.svg.elem("g"),h=this.svg.elem("g").addClass(a.classNames.labelGroup);if(a.stackBars){var i=c.serialMap(d.normalized,function(){return Array.prototype.slice.call(arguments).map(function(a){return a}).reduce(function(a,b){return{x:a.x+b.x||0,y:a.y+b.y||0}},{x:0,y:0})});b=c.getHighLow([i],c.extend({},a,{referenceValue:0}),a.horizontalBars?"x":"y")}else b=c.getHighLow(d.normalized,c.extend({},a,{referenceValue:0}),a.horizontalBars?"x":"y");b.high=+a.high||(0===a.high?0:b.high),b.low=+a.low||(0===a.low?0:b.low);var j,k,l,m,n,o=c.createChartRect(this.svg,a,f.padding);k=a.distributeSeries&&a.stackBars?d.raw.labels.slice(0,1):d.raw.labels,a.horizontalBars?(j=m=void 0===a.axisX.type?new c.AutoScaleAxis(c.Axis.units.x,d,o,c.extend({},a.axisX,{highLow:b,referenceValue:0})):a.axisX.type.call(c,c.Axis.units.x,d,o,c.extend({},a.axisX,{highLow:b,referenceValue:0})),l=n=void 0===a.axisY.type?new c.StepAxis(c.Axis.units.y,d,o,{ticks:k}):a.axisY.type.call(c,c.Axis.units.y,d,o,a.axisY)):(l=m=void 0===a.axisX.type?new c.StepAxis(c.Axis.units.x,d,o,{ticks:k}):a.axisX.type.call(c,c.Axis.units.x,d,o,a.axisX),j=n=void 0===a.axisY.type?new c.AutoScaleAxis(c.Axis.units.y,d,o,c.extend({},a.axisY,{highLow:b,referenceValue:0})):a.axisY.type.call(c,c.Axis.units.y,d,o,c.extend({},a.axisY,{highLow:b,referenceValue:0})));var p=a.horizontalBars?o.x1+j.projectValue(0):o.y1-j.projectValue(0),q=[];l.createGridAndLabels(e,h,this.supportsForeignObject,a,this.eventEmitter),j.createGridAndLabels(e,h,this.supportsForeignObject,a,this.eventEmitter),d.raw.series.forEach(function(b,e){var f,h,i=e-(d.raw.series.length-1)/2;f=a.distributeSeries&&!a.stackBars?l.axisLength/d.normalized.length/2:a.distributeSeries&&a.stackBars?l.axisLength/2:l.axisLength/d.normalized[e].length/2,h=g.elem("g"),h.attr({"series-name":b.name,meta:c.serialize(b.meta)},c.xmlNs.uri),h.addClass([a.classNames.series,b.className||a.classNames.series+"-"+c.alphaNumerate(e)].join(" ")),d.normalized[e].forEach(function(g,k){var r,s,t,u;if(u=a.distributeSeries&&!a.stackBars?e:a.distributeSeries&&a.stackBars?0:k,r=a.horizontalBars?{x:o.x1+j.projectValue(g&&g.x?g.x:0,k,d.normalized[e]),y:o.y1-l.projectValue(g&&g.y?g.y:0,u,d.normalized[e])}:{x:o.x1+l.projectValue(g&&g.x?g.x:0,u,d.normalized[e]),y:o.y1-j.projectValue(g&&g.y?g.y:0,k,d.normalized[e])},l instanceof c.StepAxis&&(l.options.stretch||(r[l.units.pos]+=f*(a.horizontalBars?-1:1)),r[l.units.pos]+=a.stackBars||a.distributeSeries?0:i*a.seriesBarDistance*(a.horizontalBars?-1:1)),t=q[k]||p,q[k]=t-(p-r[l.counterUnits.pos]),void 0!==g){var v={};v[l.units.pos+"1"]=r[l.units.pos],v[l.units.pos+"2"]=r[l.units.pos],v[l.counterUnits.pos+"1"]=a.stackBars?t:p,v[l.counterUnits.pos+"2"]=a.stackBars?q[k]:r[l.counterUnits.pos],v.x1=Math.min(Math.max(v.x1,o.x1),o.x2),v.x2=Math.min(Math.max(v.x2,o.x1),o.x2),v.y1=Math.min(Math.max(v.y1,o.y2),o.y1),v.y2=Math.min(Math.max(v.y2,o.y2),o.y1),s=h.elem("line",v,a.classNames.bar).attr({value:[g.x,g.y].filter(function(a){return a}).join(","),meta:c.getMetaData(b,k)},c.xmlNs.uri),
this.eventEmitter.emit("draw",c.extend({type:"bar",value:g,index:k,meta:c.getMetaData(b,k),series:b,seriesIndex:e,axisX:m,axisY:n,chartRect:o,group:h,element:s},v))}}.bind(this))}.bind(this)),this.eventEmitter.emit("created",{bounds:j.bounds,chartRect:o,axisX:m,axisY:n,svg:this.svg,options:a})}function e(a,b,d,e){c.Bar["super"].constructor.call(this,a,b,f,c.extend({},f,d),e)}var f={axisX:{offset:30,position:"end",labelOffset:{x:0,y:0},showLabel:!0,showGrid:!0,labelInterpolationFnc:c.noop,scaleMinSpace:30,onlyInteger:!1},axisY:{offset:40,position:"start",labelOffset:{x:0,y:0},showLabel:!0,showGrid:!0,labelInterpolationFnc:c.noop,scaleMinSpace:20,onlyInteger:!1},width:void 0,height:void 0,high:void 0,low:void 0,onlyInteger:!1,chartPadding:{top:15,right:15,bottom:5,left:10},seriesBarDistance:15,stackBars:!1,horizontalBars:!1,distributeSeries:!1,reverseData:!1,classNames:{chart:"ct-chart-bar",horizontalBars:"ct-horizontal-bars",label:"ct-label",labelGroup:"ct-labels",series:"ct-series",bar:"ct-bar",grid:"ct-grid",gridGroup:"ct-grids",vertical:"ct-vertical",horizontal:"ct-horizontal",start:"ct-start",end:"ct-end"}};c.Bar=c.Base.extend({constructor:e,createChart:d})}(window,document,a),function(a,b,c){"use strict";function d(a,b,c){var d=b.x>a.x;return d&&"explode"===c||!d&&"implode"===c?"start":d&&"implode"===c||!d&&"explode"===c?"end":"middle"}function e(a){var b,e,f,h,i,j=[],k=a.startAngle,l=c.getDataArray(this.data,a.reverseData);this.svg=c.createSvg(this.container,a.width,a.height,a.donut?a.classNames.chartDonut:a.classNames.chartPie),e=c.createChartRect(this.svg,a,g.padding),f=Math.min(e.width()/2,e.height()/2),i=a.total||l.reduce(function(a,b){return a+b},0),f-=a.donut?a.donutWidth/2:0,h="outside"===a.labelPosition||a.donut?f:"center"===a.labelPosition?0:f/2,h+=a.labelOffset;var m={x:e.x1+e.width()/2,y:e.y2+e.height()/2},n=1===this.data.series.filter(function(a){return a.hasOwnProperty("value")?0!==a.value:0!==a}).length;a.showLabel&&(b=this.svg.elem("g",null,null,!0));for(var o=0;o<this.data.series.length;o++){var p=this.data.series[o];j[o]=this.svg.elem("g",null,null,!0),j[o].attr({"series-name":p.name},c.xmlNs.uri),j[o].addClass([a.classNames.series,p.className||a.classNames.series+"-"+c.alphaNumerate(o)].join(" "));var q=k+l[o]/i*360;q-k===360&&(q-=.01);var r=c.polarToCartesian(m.x,m.y,f,k-(0===o||n?0:.2)),s=c.polarToCartesian(m.x,m.y,f,q),t=new c.Svg.Path(!a.donut).move(s.x,s.y).arc(f,f,0,q-k>180,0,r.x,r.y);a.donut||t.line(m.x,m.y);var u=j[o].elem("path",{d:t.stringify()},a.donut?a.classNames.sliceDonut:a.classNames.slicePie);if(u.attr({value:l[o],meta:c.serialize(p.meta)},c.xmlNs.uri),a.donut&&u.attr({style:"stroke-width: "+ +a.donutWidth+"px"}),this.eventEmitter.emit("draw",{type:"slice",value:l[o],totalDataSum:i,index:o,meta:p.meta,series:p,group:j[o],element:u,path:t.clone(),center:m,radius:f,startAngle:k,endAngle:q}),a.showLabel){var v=c.polarToCartesian(m.x,m.y,h,k+(q-k)/2),w=a.labelInterpolationFnc(this.data.labels?this.data.labels[o]:l[o],o);if(w||0===w){var x=b.elem("text",{dx:v.x,dy:v.y,"text-anchor":d(m,v,a.labelDirection)},a.classNames.label).text(""+w);this.eventEmitter.emit("draw",{type:"label",index:o,group:b,element:x,text:""+w,x:v.x,y:v.y})}}k=q}this.eventEmitter.emit("created",{chartRect:e,svg:this.svg,options:a})}function f(a,b,d,e){c.Pie["super"].constructor.call(this,a,b,g,c.extend({},g,d),e)}var g={width:void 0,height:void 0,chartPadding:5,classNames:{chartPie:"ct-chart-pie",chartDonut:"ct-chart-donut",series:"ct-series",slicePie:"ct-slice-pie",sliceDonut:"ct-slice-donut",label:"ct-label"},startAngle:0,total:void 0,donut:!1,donutWidth:60,showLabel:!0,labelOffset:0,labelPosition:"inside",labelInterpolationFnc:c.noop,labelDirection:"neutral",reverseData:!1};c.Pie=c.Base.extend({constructor:f,createChart:e,determineAnchorPosition:d})}(window,document,a),a});
// Set of used colors in the chart
window.chartist = window.chartist || {};
window.chartist.colorMapping = {
	'myColor': '#47A82E', //$cerulean
	'swissColor': '#A3C33C', //$blue-c
	'mapMin': '#D8D8D8',
	'mapMedium': '#B7B0AC',
	'mapMax': '#827f7f',
	'referenceColor': '#47A82E', //$cerulean
	'L02': '#bbd272', // Migros Bio
	'L10': '#905f02', // Bio Cotton
	'L33': '#47a82f', // Bio Garden
	'L14': '#ff5800', // Terra Suisse
	'L07': '#ffd200', // Eco
	'D06': '#f2d87c', // Alnatura
	'L05': '#ff9000', // MSC
	'L36': '#ecfcb4', // ASC
	'L04': '#642707', // Max Havelaar
	'L34': '#b84102', // UTZ
	'L09': '#9fc427', // FSC
	'L16': '#fb8d54' // TopTen
};

/*
 * Extending the getHighLow calculation with the
 * highOffset and lowOffset
 * options to allow offsets.
 */
Chartist.getHighLow = function (data, options, dimension) {
	// TODO: Remove workaround for deprecated global high / low config. Axis high / low configuration is preferred
	options = Chartist.extend({}, options, dimension ? options['axis' + dimension.toUpperCase()] : {});

	var highLow = {
			high: options.high === undefined ? -Number.MAX_VALUE : +options.high,
			low: options.low === undefined ? Number.MAX_VALUE : +options.low
		},
		findHigh = options.high === undefined,
		findLow = options.low === undefined;

	// Function to recursively walk through arrays and find highest and lowest number
	function recursiveHighLow(data) {
		if(data === undefined) {
			return undefined;
		} else if(data instanceof Array) {
			for (var i = 0; i < data.length; i++) {
				recursiveHighLow(data[i]);
			}
		} else {
			var value = dimension ? +data[dimension] : +data;

			if (findHigh && value > highLow.high) {
				highLow.high = value;
			}

			if (findLow && value < highLow.low) {
				highLow.low = value;
			}
		}
	}

	// Start to find highest and lowest number recursively
	if(findHigh || findLow) {
		recursiveHighLow(data);
	}

	// If high and low are the same because of misconfiguration or flat data (only the same value) we need
	// to set the high or low to 0 depending on the polarity
	if (highLow.high <= highLow.low) {
		// If both values are 0 we set high to 1
		if (highLow.low === 0) {
			highLow.high = 1;
		} else if (highLow.low < 0) {
			// If we have the same negative value for the bounds we set bounds.high to 0
			highLow.high = 0;
		} else {
			// If we have the same positive value for the bounds we set bounds.low to 0
			highLow.low = 0;
		}
	}

	// Enable offset for bar chart
	if (options.highOffset) {
		highLow.high += options.highOffset;
	}
	if (options.lowOffset) {
		highLow.low -= options.lowOffset;
	}

	return highLow;
};

/**
 * Creates the pie chart
 * Extending to creates gaps between the segments
 * TODO find a way to use the defaultOptions and determineAnchorPosition function of the main implementation
 *
 * @param options
 */
Chartist.Pie.prototype.createChart = function(options) {
	var seriesGroups = [],
		chartRect,
		radius,
		labelRadius,
		totalDataSum,
		startAngle = options.startAngle,
		dataArray = Chartist.getDataArray(this.data, options.reverseData);

	/**
	 * Default options in line charts. Expand the code view to see a detailed list of options with comments.
	 *
	 * @memberof Chartist.Pie
	 */
	var defaultOptions = {
		// Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
		width: undefined,
		// Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
		height: undefined,
		// Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
		chartPadding: 5,
		// Override the class names that are used to generate the SVG structure of the chart
		classNames: {
			chartPie: 'ct-chart-pie',
			chartDonut: 'ct-chart-donut',
			series: 'ct-series',
			slicePie: 'ct-slice-pie',
			sliceDonut: 'ct-slice-donut',
			label: 'ct-label'
		},
		// The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
		startAngle: 0,
		// An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
		total: undefined,
		// If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
		donut: false,
		// Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
		donutWidth: 60,
		// If a label should be shown or not
		showLabel: true,
		// Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
		labelOffset: 0,
		// This option can be set to 'inside', 'outside' or 'center'. Positioned with 'inside' the labels will be placed on half the distance of the radius to the border of the Pie by respecting the 'labelOffset'. The 'outside' option will place the labels at the border of the pie and 'center' will place the labels in the absolute center point of the chart. The 'center' option only makes sense in conjunction with the 'labelOffset' option.
		labelPosition: 'inside',
		// An interpolation function for the label value
		labelInterpolationFnc: Chartist.noop,
		// Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
		labelDirection: 'neutral',
		// If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
		reverseData: false
	};

	/**
	 * Determines SVG anchor position based on direction and center parameter
	 *
	 * @param center
	 * @param label
	 * @param direction
	 * @return {string}
	 */
	function determineAnchorPosition(center, label, direction) {
		var toTheRight = label.x > center.x;

		if(toTheRight && direction === 'explode' ||
			!toTheRight && direction === 'implode') {
			return 'start';
		} else if(toTheRight && direction === 'implode' ||
			!toTheRight && direction === 'explode') {
			return 'end';
		} else {
			return 'middle';
		}
	}

	// Create SVG.js draw
	this.svg = Chartist.createSvg(this.container, options.width, options.height,options.donut ? options.classNames.chartDonut : options.classNames.chartPie);
	// Calculate charting rect
	chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
	// Get biggest circle radius possible within chartRect
	radius = Math.min(chartRect.width() / 2, chartRect.height() / 2);
	// Calculate total of all series to get reference value or use total reference from optional options
	totalDataSum = options.total || dataArray.reduce(function(previousValue, currentValue) {
		return previousValue + currentValue;
	}, 0);

	// If this is a donut chart we need to adjust our radius to enable strokes to be drawn inside
	// Unfortunately this is not possible with the current SVG Spec
	// See this proposal for more details: http://lists.w3.org/Archives/Public/www-svg/2003Oct/0000.html
	radius -= options.donut ? options.donutWidth / 2  : 0;

	// If labelPosition is set to `outside` or a donut chart is drawn then the label position is at the radius,
	// if regular pie chart it's half of the radius
	if(options.labelPosition === 'outside' || options.donut) {
		labelRadius = radius;
	} else if(options.labelPosition === 'center') {
		// If labelPosition is center we start with 0 and will later wait for the labelOffset
		labelRadius = 0;
	} else {
		// Default option is 'inside' where we use half the radius so the label will be placed in the center of the pie
		// slice
		labelRadius = radius / 2;
	}
	// Add the offset to the labelRadius where a negative offset means closed to the center of the chart
	labelRadius += options.labelOffset;

	// Calculate end angle based on total sum and current data value and offset with padding
	var center = {
		x: chartRect.x1 + chartRect.width() / 2,
		y: chartRect.y2 + chartRect.height() / 2
	};

	// Check if there is only one non-zero value in the series array.
	var hasSingleValInSeries = this.data.series.filter(function(val) {
			return val.hasOwnProperty('value') ? val.value !== 0 : val !== 0;
		}).length === 1;

	// Draw the series
	// initialize series groups
	for (var i = 0; i < this.data.series.length; i++) {
		var series = this.data.series[i];
		seriesGroups[i] = this.svg.elem('g', null, null, true);

		// If the series is an object and contains a name or meta data we add a custom attribute
		seriesGroups[i].attr({
			'series-name': series.name
		}, Chartist.xmlNs.uri);

		// Use series class from series data or if not set generate one
		seriesGroups[i].addClass([
			options.classNames.series,
			(series.className || options.classNames.series + '-' + Chartist.alphaNumerate(i))
		].join(' '));

		var endAngle = startAngle + dataArray[i] / totalDataSum * 360;
		// If we need to draw the arc for all 360 degrees we need to add a hack where we close the circle
		// with Z and use 359.99 degrees
		if(endAngle - startAngle === 360) {
			endAngle -= 0.01;
		}

		var gapLength = 0.6;

		var start = Chartist.polarToCartesian(center.x, center.y, radius, startAngle - (i === 0 || hasSingleValInSeries ? 0 : 0.2) + gapLength),
			end = Chartist.polarToCartesian(center.x, center.y, radius, endAngle - gapLength );

		// Create a new path element for the pie chart. If this isn't a donut chart we should close the path for a correct stroke
		var path = new Chartist.Svg.Path(!options.donut)
			.move(end.x, end.y)
			.arc(radius, radius, 0, endAngle - startAngle > 180, 0, start.x, start.y);

		// If regular pie chart (no donut) we add a line to the center of the circle for completing the pie
		if(!options.donut) {
			path.line(center.x, center.y);
		}

		// Create the SVG path
		// If this is a donut chart we add the donut class, otherwise just a regular slice
		var pathElement = seriesGroups[i].elem('path', {
			d: path.stringify()
		}, options.donut ? options.classNames.sliceDonut : options.classNames.slicePie);

		// Adding the pie series value to the path
		pathElement.attr({
			'value': dataArray[i],
			'meta': Chartist.serialize(series.meta)
		}, Chartist.xmlNs.uri);

		// If this is a donut, we add the stroke-width as style attribute
		if(options.donut) {
			pathElement.attr({
				'style': 'stroke-width: ' + (+options.donutWidth) + 'px'
			});
		}

		// Fire off draw event
		this.eventEmitter.emit('draw', {
			type: 'slice',
			value: dataArray[i],
			totalDataSum: totalDataSum,
			index: i,
			meta: series.meta,
			series: series,
			group: seriesGroups[i],
			element: pathElement,
			path: path.clone(),
			center: center,
			radius: radius,
			startAngle: startAngle,
			endAngle: endAngle
		});

		// If we need to show labels we need to add the label for this slice now
		if(options.showLabel) {
			// Position at the labelRadius distance from center and between start and end angle
			var labelPosition = Chartist.polarToCartesian(center.x, center.y, labelRadius, startAngle + (endAngle - startAngle) / 2),
				interpolatedValue = options.labelInterpolationFnc(this.data.labels ? this.data.labels[i] : dataArray[i], i);

			if(interpolatedValue || interpolatedValue === 0) {
				var labelElement = seriesGroups[i].elem('text', {
					dx: labelPosition.x,
					dy: labelPosition.y,
					'text-anchor': determineAnchorPosition(center, labelPosition, options.labelDirection)
				}, options.classNames.label).text('' + interpolatedValue);

				// Fire off draw event
				this.eventEmitter.emit('draw', {
					type: 'label',
					index: i,
					group: seriesGroups[i],
					element: labelElement,
					text: '' + interpolatedValue,
					x: labelPosition.x,
					y: labelPosition.y
				});
			}
		}

		// Set next startAngle to current endAngle. Use slight offset so there are no transparent hairline issues
		// (except for last slice)
		startAngle = endAngle;
	}

	this.eventEmitter.emit('created', {
		chartRect: chartRect,
		svg: this.svg,
		options: options
	});
};

(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define([], function () {
			return (root.returnExportsGlobal = factory());
		});
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like enviroments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		root['Chartist.plugins.pointlabels'] = factory();
	}
}(this, function () {

	/**
	 * Chartist.js plugin to display a data label on top of the points in a line chart.
	 *
	 */
	/* global Chartist */
	(function (window, document, Chartist) {
		'use strict';

		var defaultOptions = {
			labelClass: 'ct-label',
			labelOffset: {
				x: 0,
				y: -10
			},
			textAnchor: 'middle'
		};

		Chartist.plugins = Chartist.plugins || {};
		Chartist.plugins.pointlabel = function (options) {
			options = Chartist.extend({}, defaultOptions, options);

			return function pointlabel(chart) {
				if (chart instanceof Chartist.Line) {
					chart.on('draw', function (data) {
						// With the type 'reference' the line gets no labels
						if (data.type === 'point' && (!data.series.type || data.series.type !== 'reference')) {
							data.group.elem('text', {
								x: data.x + options.labelOffset.x,
								y: data.y + options.labelOffset.y,
								style: 'text-anchor: ' + options.textAnchor
							}, options.labelClass).text(data.value.y + '%');
						}
						else if (data.type === 'point' && data.series.type && data.series.type === 'reference') {
							data.group.addClass('ct-reference');
						}
					});
				}
				else if (chart instanceof Chartist.Bar) {
					chart.on('draw', function (data) {
						if (data.type === 'bar') {
							data.group.elem('text', {
								x: data.x1 + options.labelOffset.x,
								y: data.y2 + options.labelOffset.y,
								style: 'text-anchor: ' + options.textAnchor
							}, options.labelClass).text(data.value.y + '%');
						}
					});
				}
			};
		};

	}(window, document, Chartist));

	return Chartist.plugins.pointlabels;

}));

(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define([], function () {
			return (root.returnExportsGlobal = factory());
		});
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like enviroments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		root['Chartist.plugins.referencelines'] = factory();
	}
}(this, function () {

	/**
	 * Chartist.js plugin to display a reference line in a line chart.
	 *
	 */
	/* global Chartist */
	(function (window, document, Chartist) {
		'use strict';

		var defaultOptions = {
			labelClass: 'ct-label',
			labelOffset: {
				x: 0,
				y: -10
			},
			textAnchor: 'middle'
		};

		Chartist.plugins = Chartist.plugins || {};
		Chartist.plugins.referenceline = function (options) {
			options = Chartist.extend({}, defaultOptions, options);

			return function referenceline(chart) {
				if (chart instanceof Chartist.Line) {
					chart.on('draw', function (data) {
						// With the type 'reference' the line gets no labels
						if (data.type === 'point' && data.series.type && data.series.type === 'reference') {
							data.group.addClass('ct-reference');
						}
					});
				}
			};
		};

	}(window, document, Chartist));

	return Chartist.plugins.referencelines;

}));

(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define([], function () {
			return (root.returnExportsGlobal = factory());
		});
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like enviroments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		root['Chartist.plugins.tooltips'] = factory();
	}
}(this, function () {

	/**
	 * Chartist.js plugin to display a data label on top of the points in a line chart.
	 *
	 */
	/* global Chartist */
	(function (window, document, Chartist) {
		'use strict';

		var defaultOptions = {
			currency: null
			// showTooltips: true,
			// tooltipEvents: ['mousemove', 'touchstart', 'touchmove'],
			// labelClass: 'ct-label',
			// labelOffset: {
			//   x: 0,
			//   y: -10
			// },
			// textAnchor: 'middle'
		};

		Chartist.plugins = Chartist.plugins || {};
		Chartist.plugins.tooltip = function (options) {
			options = Chartist.extend({}, defaultOptions, options);

			var type = 'line';
			return function tooltip(chart) {
				var tooltipSelector = '.ct-point';
				if (chart instanceof Chartist.Bar) {
					tooltipSelector = '.ct-bar';
					type = 'bar';
				} else if (chart instanceof Chartist.Pie) {
					if (chart.options.donut === true) {
						tooltipSelector = '.ct-slice-donut';
						type = 'donut';
					} else {
						tooltipSelector = '.ct-slice';
						type = 'pie';
					}
				}

				var $chart = $(chart.container);
				var $toolTip = $chart
					.append('<div class="tooltip"></div>')
					.find('.tooltip')
					.hide();

				$chart.on('mouseenter click', tooltipSelector, function () {
					var $point = $(this);
					var tooltipText = '';

					if (typeof options.valueFct === 'function') {
						tooltipText = options.valueFct($point);
					}
					else {
						// Default value function
						if ($point.attr('ct:meta')) {
							tooltipText += $point.attr('ct:meta') + '<br>';
						} else if (type === 'pie') {
							// For Pie Charts also take the labels into account
							// Could add support for more charts here as well!
							var label = $point.next('.ct-label');
							if (label.length > 0) {
								tooltipText += label.text() + '<br>';
							}
						}

						var value = $point.attr('ct:value');
						if (options.currency) {
							value = options.currency + value.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
						}
						tooltipText += value;
					}

					$toolTip.html(tooltipText).show();
				});

				$chart.on('mouseleave', tooltipSelector, function () {
					$toolTip.hide();
				});

				$chart.on('mousemove', function (event) {
					$toolTip.css({
						left: (event.offsetX || event.originalEvent.layerX) - $toolTip.width() / 2 - 10,
						top: (event.offsetY || event.originalEvent.layerY) - $toolTip.height() - 40
					});
				});
			};
		};

	}(window, document, Chartist));

	return Chartist.plugins.tooltips;

}));

$(function () {
	$('[data-mch-module=green] [data-toggle=popover]').uiPopOverComponent();
});

// From https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
function getInternetExplorerVersion()
// Returns the version of Internet Explorer or a -1
{
	var rv = -1; // Return value assumes failure.
	if (navigator.appName === 'Microsoft Internet Explorer')
	{
		var ua = navigator.userAgent;
		var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
		if (re.exec(ua) !== null) {
			rv = parseFloat(RegExp.$1);
		}
	}
	return rv;
}

// From http://stackoverflow.com/questions/2631001/javascript-test-for-existence-of-nested-object-key
function doesNestedPropertyExist(obj /*, level1, level2, ... levelN*/) {
	var args = Array.prototype.slice.call(arguments, 1);

	for (var i = 0; i < args.length; i++) {
		if (!obj || !obj.hasOwnProperty(args[i])) {
			return false;
		}
		obj = obj[args[i]];
	}
	return true;
}

(function ($) {
	'use strict';
	/**
	 * Dropdown module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class Dropdown
	 * @extends T.Module
	 */
	T.Module.Dropdown = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx._events.on('t.sync', ctx.sync.bind(this));
			ctx.isPushStateEnabled = ctx.isPushStateEnabled();
			ctx.sync = true;

			$ctx.on('click keypress', '.js-dropdown__menu__item', function (e) {
				var $this = $(this),
					optionKey = $ctx.data('option-key'),
					optionValue = $this.data('value'),
					optionText = $('.js-dropdown__menu__item[data-value=' + optionValue + ']', $ctx).text();

				$ctx.removeClass('js-dropdown__is-unset');

				e.preventDefault();

				ctx.hideDropdown();

				ctx.dropdownSetValue($this.text(), optionValue);

				ctx.triggerDependentDropdowns(optionKey, optionValue, optionText);

			});

			ctx._ensureSelection();

			resolve();
		},
		// Set option selection based on query parameters
		sync: function () {
			var ctx = this;

			// only sync once
			if (ctx.sync) {
				// Handle selection
				var $ctx = $(this._ctx),
					optionKey = $ctx.data('option-key'),
					// load preselection from url or attribute
					optionValue = $ctx.data('selected-value'),
					$option = $('.js-dropdown__menu__item[data-value=' + optionValue + ']', $ctx),
					selectionExists = $option.length > 0,
					optionText = $option.text();

				if (selectionExists && optionKey && optionValue && optionText) {
					$ctx.removeClass('js-dropdown__is-unset');
					ctx.dropdownSetValue(optionText, optionValue);
					ctx.triggerDependentDropdowns(optionKey, optionValue, optionText);
				}
				ctx.sync = false;
			}

			// Important mainly for the label select dropdown
			ctx._ensureSelection();
		},
		_ensureSelection: function () {
			var ctx = this,
				$ctx = $(this._ctx),
				$firstItem = $ctx.find('.js-dropdown__menu__item').first();

			if ($ctx.hasClass('js-dropdown__is-unset') && $firstItem && $firstItem.length > 0) {
				var optionText = $firstItem.text(),
					optionValue = $firstItem.data('value'),
					optionKey = $ctx.data('option-key');

				$ctx.removeClass('js-dropdown__is-unset');
				ctx.dropdownSetValue(optionText, optionValue);
				ctx._events.emit('green.dropdown.select', optionKey, optionValue, false, optionText);
			}
		},
		hideDropdown: function () {
			var $ctx = $(this._ctx);
			// Bootstrap toggle did not work correctly!
			$('.js-dropdown__toggle', $ctx).attr('aria-expanded', 'false');
			$('.js-dropdown', $ctx).removeClass('open');
		},
		dropdownSetValue: function (label, value) {
			var $ctx = $(this._ctx);
			label += '<span class="close"></span>';

			// Set label of dropdown
			$('.js-dropdown__toggle', $ctx).html(label);

			// Store value in data
			$ctx.data('selected-value', value);
		},
		// Inform other components of the new selection
		triggerDependentDropdowns: function (key, value, text) {
			var ctx = this,
				$ctx = $(this._ctx),
				$items = $('.js-dropdown__menu__item', $ctx);

			// Trigger event to show dependend dropdowns
			ctx._events.emit('green.dropdown.select', key, value, false, text);

			// Trigger event to hide deselected dependend dropdowns
			$items.each(function (deselectKey, deselectItem) {
				var $item = $(deselectItem),
					itemValue = $item.data('value');
				if (itemValue !== value) {
					ctx._events.emit('green.dropdown.deselect', itemValue);
				}
			});
		},
		isPushStateEnabled: function () {
			return history && history.pushState;
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * Map module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class Map
	 * @extends T.Module
	 */
	T.Module.Map = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.flagData = {
				'TG': {xPosition: '365', yPosition: '-30', fileName: 'Wappen_Thurgau.svg'},
				'AR': {xPosition: '394', yPosition: '14', fileName: 'Wappen_Appenzell_AR.svg'},
				'AI': {xPosition: '412', yPosition: '25', fileName: 'Wappen_Appenzell_AI.svg'},
				'SG': {xPosition: '399', yPosition: '60', fileName: 'Wappen_St_Gallen.svg'},
				'GR': {xPosition: '432', yPosition: '150', fileName: 'Wappen_Graubuenden.svg'},
				'GL': {xPosition: '367', yPosition: '90', fileName: 'Wappen_Glarus.svg'},
				'ZG': {xPosition: '294', yPosition: '54', fileName: 'Wappen_Zug.svg'},
				'ZH': {xPosition: '309', yPosition: '6', fileName: 'Wappen_Zuerich.svg'},
				'SZ': {xPosition: '322', yPosition: '76', fileName: 'Wappen_Schwyz.svg'},
				'UR': {xPosition: '307', yPosition: '123', fileName: 'Wappen_Uri.svg'},
				'TI': {xPosition: '327', yPosition: '210', fileName: 'Wappen_Tessin.svg'},
				'NW': {xPosition: '277', yPosition: '97', fileName: 'Wappen_Nidwalden.svg'},
				'SH': {xPosition: '296', yPosition: '-59', fileName: 'Wappen_Schaffhausen.svg'},
				'OW': {xPosition: '247', yPosition: '114', fileName: 'Wappen_Obwalden.svg'},
				'LU': {xPosition: '238', yPosition: '65', fileName: 'Wappen_Luzern.svg'},
				'AG': {xPosition: '245', yPosition: '5', fileName: 'Wappen_Aargau.svg'},
				'BL': {xPosition: '194', yPosition: '-1', fileName: 'Wappen_Basel_Land.svg'},
				'BS': {xPosition: '170', yPosition: '-27', fileName: 'Wappen_Basel_Stadt.svg'},
				'SO': {xPosition: '156', yPosition: '40', fileName: 'Wappen_Solothurn.svg'},
				'BE': {xPosition: '168', yPosition: '119', fileName: 'Wappen_Bern.svg'},
				'VS': {xPosition: '166', yPosition: '245', fileName: 'Wappen_Wallis.svg'},
				'JU': {xPosition: '110', yPosition: '13', fileName: 'Wappen_Jura.svg'},
				'NE': {xPosition: '61', yPosition: '85', fileName: 'Wappen_Neuenburg.svg'},
				'FR': {xPosition: '100', yPosition: '146', fileName: 'Wappen_Freiburg.svg'},
				'VD': {xPosition: '27', yPosition: '160', fileName: 'Wappen_Waadt.svg'},
				'GE': {xPosition: '-36', yPosition: '242', fileName: 'Wappen_Genf.svg'}
			};

			ctx.appContext = this._sandbox._application._config.appContext || "/";

			ctx.$flagImage = $ctx.find('.js-map__flag__svg');

			ctx.cantonCache = null;

			this._events.on('green.map.udpate', function (chartData, min, max) {
				if (doesNestedPropertyExist(chartData, 'data', 'overview')) {
					// Map
					if (doesNestedPropertyExist(chartData.data.overview, 'regionPercentages')) {
						ctx.colorMap(chartData.data.overview.regionPercentages, min, max);
					}
					// Flag
					if (doesNestedPropertyExist(chartData.data.overview, 'myRegionPercentage', 'region')) {
						ctx.showFlag(chartData.data.overview.myRegionPercentage.region);
					}
				}
			});

			resolve();
		},
		showFlag: function (activeCanton) {
			var ctx = this,
				$ctx = $(this._ctx),
				data = {},
				filePath = '';

			if (activeCanton) {
				if (ctx.cantonCache) {
					$ctx.removeClass('a-map--' + ctx.cantonCache);
				}
				$ctx.addClass('a-map--' + activeCanton);
			}

			if (ctx.flagData[activeCanton]) {
				data = ctx.flagData[activeCanton];
				var path = ctx.$flagImage.attr('data-src-path');
				filePath = path + '/img/svg/flag/' + data.fileName;

				ctx.$flagImage.show();
				ctx.$flagImage.attr('xlink:href', filePath);
				ctx.$flagImage.attr('x', data.xPosition);
				ctx.$flagImage.attr('y', data.yPosition);
			}
			else {
				ctx.$flagImage.hide();
			}
		},
		colorMap: function (data, min, max) {
			var $ctx = $(this._ctx);

			if (data) {
				$.each(data, function (index, item) {
					if (item.id) {
						var $region = $('#CH-' + item.id, $ctx),
							classAttr = $region.attr('class'),
							percentage = parseFloat(item.percentage).toFixed(1);

						// Foreign countries are not displayed as regions
						if ($region.length === 0) {
							return;
						}

						/* Cleanup class-attr as we can't rely on jQuery for SVG paths. This is basically removeClass()
						 * hackery.
						 */
						classAttr = classAttr.replace(/a-map__canton--rank-(low|high|medium)/ig, '').trim();

						if (percentage > max) {
							$region.attr('class', classAttr + ' a-map__canton--rank-high');
						} else if (percentage < min) {
							$region.attr('class', classAttr + ' a-map__canton--rank-low');
						} else {
							$region.attr('class', classAttr + ' a-map__canton--rank-medium');
						}
					}
				});
			}
			else {
				// Error should not happen
			}
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * BarChart module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class BarChart
	 * @extends T.Module
	 */
	T.Module.BarChart = T.createModule({
		start: function (resolve) {
			var $ctx = $(this._ctx);

			this.chart = null;

			var options = {
				width: '100%',
				height: $ctx.data('height') || '300px',
				highOffset: 4,
				axisX: {
					offset: 30,
					labelOffset: {
						x: 0,
						y: 10
					},
					labelInterpolationFnc: function (value) {
						// Will return Mon, Tue, Wed etc. on medium screens
						return value.substring(0, 3).toUpperCase();
					}
				},
				axisY: {
					offset: 70,
					labelOffset: {
						x: -35,
						y: 7
					},
					scaleMinSpace: 40,
					labelInterpolationFnc: function (value) {
						// Will return Mon, Tue, Wed etc. on medium screens
						return value + '%';
					}
				},
				plugins: [
					Chartist.plugins.pointlabel(),
				]
			};

			this._events.on('green.barchart.udpate', function (data) {
				if (data) {
					$ctx.show();
					if (!this.chart) {
						// Initialize chart
						this.chart = new Chartist.Bar('.js-bar-chart', data, options);
						this.chart.on('draw', function (data) {
							if (data.type === 'grid' && data.axis.units.pos === 'y' && (data.index === 0 || data.index === data.axis.ticks.length - 1)) {
								data.element.addClass('chartist__bar__edges');
							}
							if ((data.type === 'bar') && data.series.hexColor) {
								data.element.attr({'style': 'stroke:' + data.series.hexColor});
							}
							if (data.type === 'grid' && data.axis.units.pos === 'x') {
								data.element.remove();
							}
						});
					}
					else {
						this.chart.update(data);
					}
				}
				else {
					$ctx.hide();
				}
			});

			resolve();
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * CantonList module implementation.
	 *
	 * @author ernscht <ernscht@gmail.com>
	 * @namespace T.Module
	 * @class CantonList
	 * @extends T.Module
	 */
	T.Module.CantonList = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			resolve();
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * DonutChart module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class DonutChart
	 * @extends T.Module
	 */
	T.Module.DonutChart = T.createModule({
		start: function (resolve) {
			var $ctx = $(this._ctx),
				$chart = $('.js-donut-chart');

			this.chart = null;

			var options = {
				height: $ctx.data('height') || '100%',
				width: $ctx.data('height') || '100%',
				donut: true,
				donutWidth: 30,
				startAngle: 0,
				chartPadding: {top: 0, right: 5, bottom: 0, left: 0},
				plugins: [
					Chartist.plugins.tooltip({
						valueFct: function ($el) {
							var value = $el.attr('ct:value'),
								seriesName = $el.next().text();
							return seriesName + '<br>' + value + '%';
						}
					})
				]
			};

			this._events.on('green.donutchart.udpate', function (data) {
				if (!this.chart) {
					// Initialize chart
					this.chart = new Chartist.Pie('.js-donut-chart', data, options);

					this.chart.on('draw', function (data) {
						// hide labels
						if (data.type === 'label') {
							data.element.addClass('m-chartist__donut__label');
						}
						// set color of the slices
						if (data.type === 'slice' && data.series.hexColor) {
							// extend the current style settings
							var styles = {'style': data.element.attr('style') + '; stroke: ' + data.series.hexColor + ';'};
							data.element.attr(styles);
						}
					});

					// Add text within the donut hole
					this.chart.on('created', function (object) {
						$chart.find('.js-chartist__donut__title').remove(); // remove old titles
						var $title = $chart
							.append('<div class="m-chartist__donut__title js-chartist__donut__title"><span>' + data.title + '</span></div>')
							.find('.m-chartist__donut__title');

						// calculate the box fitting in the ring
						var diameter = Math.min(parseInt(object.chartRect.width()) - object.chartRect.padding.left - object.chartRect.padding.right, parseInt(object.chartRect.height()) - object.chartRect.padding.top - object.chartRect.padding.bottom),
							innerDiameter = diameter - options.donutWidth * 2,
							innerRadius = innerDiameter / 2,
							length = Math.sqrt(Math.pow(innerRadius, 2) * 2);

						// set styles to fit the box in the ring
						$title.css({
							position: 'absolute',
							left: (object.chartRect.x1 + object.chartRect.x2) / 2 - length / 2,
							top: (object.chartRect.y1 + object.chartRect.y2) / 2 - length / 2,
							width: length,
							height: length
						});
					});
				}
				else {
					this.chart.update(data);
				}
			});

			resolve();
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * LabelSelect module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class LabelSelect
	 * @extends T.Module
	 */
	T.Module.LabelSelect = T.createModule({
		start: function(resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.values = {};
			ctx.hbsSource = $($ctx.data('tpl-content')).html();
			ctx.hbsTemplate = Handlebars.compile(ctx.hbsSource);
			ctx.$dropdown = $('.js-label-select__dropdown', $ctx);

			ctx._events.on('green.chart.update', function(chartData) {
				if (doesNestedPropertyExist(chartData, 'data', 'overview', 'myLabelPercentages')) {
					var options = [];
					ctx.trackingLabels = {};
					$.each(chartData.data.overview.myLabelPercentages, function(index, value) {
						options.push({'optionText': value.label, 'optionValue': value.id});
						ctx.trackingLabels[value.label] = parseFloat(value.percentage).toFixed(1) + '%';
					});

					var data = {
						'dependent': false,
						'items': {
							'label': $ctx.data('select-label') || '',
							'class': '',
							'title': $ctx.data('select-default') || '',
							'optionKey': 'label',
							'optionDefaultValue': options[0].optionValue,
							'options': options
						}
					};

					ctx._render(data);
				}
			});

			/**
			 * Handle selection of a children dropdown
			 * key: option key
			 * value: option value
			 * focus (optional): whether to focus following dependent dropdown if existent
			 */
			this._events.on('green.dropdown.select', function(key, value, focus) {
				var $activeDropdown = $('.js-dropdown-' + value, $ctx);

				if (key === 'year') {
					$('.js-label-select__year', $ctx).text(value);
				}

				// Cache selection
				ctx.values[key] = value;

				// GTM: Only the year view is tracked at this point. The period and public view is tracked in charts.js.
				if (key === 'label') {
					ctx._events.emit('green.labelselect.change', ctx.trackingLabels, ctx.values);
				}

				// show bridge text after first dropdown is selected
				$('.js-label-select__bridge-text', $ctx).removeClass('is-hidden');

				// show dependent dropdown and set focus on it
				if ($activeDropdown.length > 0) {
					$activeDropdown.removeClass('is-hidden');
					if (focus) {
						$activeDropdown.find('.js-dropdown__toggle').focus();
					}
				}
			});

			this._events.on('green.dropdown.deselect', function(key) {
				$('.js-dropdown-' + key, $ctx).addClass('is-hidden');
			});
			resolve();
		},
		_render: function(data) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			ctx.$dropdown.html(ctx.hbsTemplate(data));

			// Modul Initialisierung kann nicht verwendet werden,
			// da das Starten des neuen Moduls den Event t.sync auslösen würde
			// und somit das Modul Dropdown ein erneutes emitten der Eventchain zur Folge hätte
			// was zu einem inifinite loop führen würde
			// -> wir machen also alles in diesem Modul
			// ==> Solved by syncing dropdown only once
			ctx._sandbox.addModules(ctx.$dropdown.get(0));
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * LineChart module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class LineChart
	 * @extends T.Module
	 */
	T.Module.LineChart = T.createModule({
		start: function (resolve) {
			var $ctx = $(this._ctx);

			this.settings = {};
			this.settings.showValues = $ctx.data('show-values') === true;
			this.chart = null;

			var options = {
				width: '100%',
				height: $ctx.data('height') || '300px',
				chartPadding: {
					top: 15,
					right: -30,
					bottom: 5,
					left: 0
				},
				lineSmooth: false,
				axisX: {
					// We can disable the grid for this axis
					showGrid: false,
					// and also don't show the label
					labelInterpolationFnc: function (value) {
						// Will return Mon, Tue, Wed etc. on medium screens
						return value.substring(0, 3).toUpperCase();
					},
					offset: 30,
					labelOffset: {
						x: -10,
						y: 10
					}
				},
				axisY: {
					onlyInteger: true,
					offset: 70,
					labelOffset: {
						x: -30,
						y: 7
					},
					low: 0,
					scaleMinSpace: 40,
					labelInterpolationFnc: function (value) {
						// Will return Mon, Tue, Wed etc. on medium screens
						return value + '%';
					}
				},
				plugins: [
					Chartist.plugins.referenceline()
				]
			};

			if (this.settings.showValues) {
				options.plugins.push(Chartist.plugins.pointlabel());
			}

			this._events.on('green.linechart.udpate', function (data) {
				if (!this.chart) {
					// Initialize chart
					this.chart = new Chartist.Line('.js-line-chart', data, options);
					this.chart.on('draw', function (data) {
						if ((data.type === 'point' || data.type === 'line') && data.series.color) {
							data.element.attr({'style': 'stroke:' + data.series.hexColor});
						}
						if (data.type === 'grid' && data.axis.units.pos === 'y' && (data.index === 0 || data.index === data.axis.ticks.length - 1)) {
							data.element.addClass('chartist__bar__edges');
						}
					});
				}
				else {
					this.chart.update(data);
				}
			});

			resolve();
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * MapChart module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class MapChart
	 * @extends T.Module
	 */
	T.Module.MapChart = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.$legend = $('.js-map-chart__info__legend', $ctx);
			ctx.hbsLegendSource = $ctx.find('#m-map-chart__legend__template').html();
			ctx.hbsLegendTemplate = Handlebars.compile(ctx.hbsLegendSource);
			ctx.$percentage = $('.js-map-chart__info__percentage', $ctx);
			ctx.hbsPercentageSource = $ctx.find('#m-map-chart__percentage__template').html();
			ctx.hbsPercentageTemplate = Handlebars.compile(ctx.hbsPercentageSource);

			ctx._events.on('green.map.udpate', function (chartData, min, max) {
				// Legend
				ctx.setLegend(min, max);

				// Status information element
				ctx.setPercentage(chartData);
			});

			resolve();
		},
		// Generate legend lines
		setLegend: function (min, max) {
			var ctx = this,
				hbsData = {},
				hbsOutput = '',
				modifier = '',
				serie = null;

			ctx.$legend.empty();

			// OPTIMISATION Reduce the following to one iterator
			hbsData = {
				'modifier': 'map',
				'color': window.chartist.colorMapping.mapMax,
				'decorator': '',
				'labels': {'legend': '> ' + max + '%'}
			};
			hbsOutput = ctx.hbsLegendTemplate(hbsData);
			ctx.$legend.append($(hbsOutput));

			hbsData = {
				'modifier': 'map',
				'color': window.chartist.colorMapping.mapMedium,
				'decorator': '',
				'labels': {'legend': min + '% - ' + max + '%'}
			};
			hbsOutput = ctx.hbsLegendTemplate(hbsData);
			ctx.$legend.append($(hbsOutput));

			hbsData = {
				'modifier': 'map',
				'color': window.chartist.colorMapping.mapMin,
				'decorator': '',
				'labels': {'legend': '< ' + min + '%'}
			};
			hbsOutput = ctx.hbsLegendTemplate(hbsData);
			ctx.$legend.append($(hbsOutput));
		},
		// Generate legend lines
		setPercentage: function (chartData) {
			var ctx = this,
				hbsData = {},
				hbsOutput = '',
				data = {},
				percent = null;

			if (doesNestedPropertyExist(chartData, 'canton', 'mapChart', 'percentageLegendMapSwiss')) {
				data = chartData.canton.mapChart.percentageLegendMapSwiss;


				// Render element
				hbsOutput = ctx.hbsPercentageTemplate(data);
				ctx.$percentage.html($(hbsOutput));
			}
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * PeriodSelect module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class PeriodSelect
	 * @extends T.Module
	 */
	T.Module.PeriodSelect = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);


			ctx.values = {};

			/**
			 * Handle selection of a children dropdown
			 * key: option key
			 * value: option value
			 * focus (optional): whether to focus following dependent dropdown if existent
			 */
			this._events.on('green.dropdown.select', function (key, value, focus) {
				var $activeDropdown = $('.js-dropdown-' + value, $ctx),
					type = false,
					isReloadKey = false;

				// Cache selection
				ctx.values[key] = value;

				// show bridge text after first dropdown is selected
				if (key === 'type') {
					$('.js-period-select__bridge-text', $ctx).removeClass('is-hidden');
				}

				// show dependent dropdown and set focus on it
				if ($activeDropdown.length > 0) {
					$activeDropdown.removeClass('is-hidden');
					if (focus) {
						$activeDropdown.find('.js-dropdown__toggle').focus();
					}
				}

				type = ctx.values.type;
				isReloadKey = (key === type || key === 'type');

				// React on type selector and its dependend dropdown
				if (type && isReloadKey && ctx.values[type]) {
					ctx._events.emit('green.chart.reload', type, ctx.values[type]);
				}
			});

			this._events.on('green.dropdown.deselect', function (key) {
				$('.js-dropdown-' + key, $ctx).addClass('is-hidden');
			});

			resolve();
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * TeaserPersonalized module implementation.
	 *
	 * @author Florian Gaechter <florian.gaechter@namics.com>
	 * @namespace T.Module
	 * @class TeaserPersonalized
	 * @extends T.Module
	 */
	T.Module.TeaserPersonalized = T.createModule({
		start: function(resolve) {
			var $ctx = $(this._ctx);

			resolve();
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * Canton module implementation.
	 *
	 * @author ernscht <ernscht@gmail.com>
	 * @namespace T.Module
	 * @class Canton
	 * @extends T.Module
	 */
	T.Module.Canton = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.hbsSource = $($ctx.data('tpl-content')).html();
			ctx.hbsTemplate = Handlebars.compile(ctx.hbsSource);
			ctx.data = {};
			ctx.threshold = {
				min: parseFloat($ctx.data('threshold-min')) || 17,
				max: parseFloat($ctx.data('threshold-max')) || 15
			};
			ctx.visibleItems = $ctx.data('visible-items') || 5;

			ctx._events.on('green.chart.update', function (chartData) {

				if (doesNestedPropertyExist(chartData, 'data', 'overview')) {
					ctx._events.emit('green.map.udpate', chartData, ctx.threshold.min, ctx.threshold.max);

					ctx.data = chartData.data.overview;

					if (doesNestedPropertyExist(chartData, 'canton', 'cantonList')) {
						if (doesNestedPropertyExist(chartData.canton.cantonList, 'year')) {
							// Year
							ctx.data.year = chartData.canton.cantonList.year;
						}
						if (doesNestedPropertyExist(chartData.canton.cantonList, 'myGoal')) {
							// My Goal Text
							ctx.data.myGoal = chartData.canton.cantonList.myGoal;
						}

						// Button
						if (doesNestedPropertyExist(chartData.canton.cantonList, 'moreButtonText')) {
							ctx.data.moreButtonText = chartData.canton.cantonList.moreButtonText;
						}
						if (doesNestedPropertyExist(chartData.canton.cantonList, 'lessButtonText')) {
							ctx.data.lessButtonText = chartData.canton.cantonList.lessButtonText;
						}
					}

					// Range legend
					if (chartData.range) {
						ctx.data.range = chartData.range;
					}

					ctx._prepareListData();
					ctx._render();
				}
			});

			$ctx.on('click', '.js-m-canton-list__action', function (e) {
				e.preventDefault();
				var $button = $(this),
					$toggle = $button.closest('.js-m-canton-list__toggle');
					// $list = $toggle.closest('.js-m-canton-list');

				$ctx.find('.js-m-canton-list__item--hidden').fadeToggle(300);
				// if ($toggle.hasClass('state-visible')) {
				// 	// scroll to top of the list. Offset of 15px especialy for mobile.
				// 	$('html, body').animate({scrollTop: $list.offset().top - 15}, 300);
				// }
				setTimeout(function () {
					$toggle.toggleClass('state-visible');
				}, 300);
			});

			resolve();
		},

		_render: function () {
			var ctx = this,
				$ctx = $(ctx._ctx),
				data = ctx.data,
				$container = $ctx.find('.js-o-canton__content');

			$container.html(ctx.hbsTemplate(data));

			// Modul Initialisierung kann nicht verwendet werden,
			// da das Starten des neuen Moduls den Event t.sync auslösen würde
			// und somit das Modul Dropdown ein erneutes emitten der Eventchain zur Folge hätte
			// was zu einem inifinite loop führen würde
			// -> wir machen also alles in diesem Modul
			ctx._sandbox.addModules($container.get(0));
		},

		_prepareListData: function () {
			var ctx = this,
				data = ctx.data,
				maxPercentage = 30,
				nrOfSteps = 6,
				step = 5; // default

			function getMax(key, obj) {
				// get maximum and add visual percentage ( rounded, with `%` sign)
				if (key === 'percentage') {
					if (obj[key] > maxPercentage) {
						maxPercentage = obj[key];
					}
					obj.visualPercentage = ctx._getPercentage(obj[key]);
				}
			}
			function calcPercentage(key, obj) {
				// calculate the relative percentage for the chart
				if (key === 'percentage') {
					obj.chartPercentage = 100 / maxPercentage * obj[key];
				}
			}
			function iterate(obj, stack, action) {
				for (var key in obj) {
					if (obj.hasOwnProperty(key)) {
						if (typeof obj[key] === 'object') {
							iterate(obj[key], stack + '.' + key, action);
						}
						else {
							action(key, obj);
						}
					}
				}
			}

            // Iterate over all values
			iterate(data.countryPercentage, '', getMax);
			iterate(data.regionPercentages, '', getMax);
			iterate(data.myPercentage, '', getMax);
			iterate(data.myRegionPercentage, '', getMax);

			// Need to be in advance of processing the maxPercentage!
			(function mapGoal() {
				var year = data.year,
					goalPercentage = 0;

				if (data.goals && data.goals[year]) {
					goalPercentage = data.goals[year];
					// reset maxPercentag if needed
					if (goalPercentage > maxPercentage) {
						maxPercentage = goalPercentage;
					}
					data.goal = {
						percentage: goalPercentage,
						visualPercentage: ctx._getPercentage(goalPercentage),
						chartPercentage: 100 / maxPercentage * goalPercentage
					};

					// Handle position of the goal label
					if (goalPercentage < 10) {
						data.goal.goalLeft = true;
					}
					else if (goalPercentage > 25) {
						data.goal.goalRight = true;
					}
					else {
						// do nothing. default.
					}
				}
			})();

			// Set step dynamically (defined by the nr of steps)
			step = Math.ceil(maxPercentage / nrOfSteps);

            // Round maxPercentage to next step
			maxPercentage = Math.ceil(maxPercentage / step) * step;

            // Scale percentage respecting the maxPercentage
			iterate(data, '', calcPercentage);

			(function mapCantons() {
				var key, i;
				data.cantons = [];
				if (data.regionPercentages) {
					// collect
					for (key in data.regionPercentages) {
						if (data.regionPercentages.hasOwnProperty(key)) {
							data.cantons.push(data.regionPercentages[key]);
						}
					}
					// sort
					data.cantons.sort(function (a, b) {
						return ((a.percentage < b.percentage) ? 1 : ((a.percentage > b.percentage) ? -1 : 0));
					});
					//enrich
					for (i = 0; i < data.cantons.length; i++) {
						data.cantons[i].rank = i + 1;
						if (data.cantons[i].percentage > ctx.threshold.max) {
							data.cantons[i].above = true;
						}
						else if (data.cantons[i].percentage < ctx.threshold.min) {
							data.cantons[i].below = true;
						}
						if (i + 1 > ctx.visibleItems) {
							data.cantons[i].hidden = true;
						}
					}


					// add threshold info & divider

				}
			})();

			(function mapGrid() {
				var i = 0;
				data.gridlines = {};

				while (i < maxPercentage) {
					data.gridlines[i] = {
						percentage: 100 / maxPercentage * i,
						value: i + '%',
						edge: false
					};
					i += step;
				}
				data.gridlines[i] = {
					percentage: 100 / maxPercentage * i,
					value: i + '%',
					edge: true
				};
				data.gridlines[0].edge = true;
			})();
		},

		_getPercentage: function (num) {
			return num.toFixed(1) + '%';
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * LabelOverview module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class LabelOverview
	 * @extends T.Module
	 */
	T.Module.LabelOverview = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			if (getInternetExplorerVersion() === 9) {
				$ctx.addClass('is-ie9');
			}

			ctx.viewport = (ui && ui.Bootstrap && ui.Bootstrap.activeView) ? ui.Bootstrap.activeView : 'xs';
			ctx.visible = false;
			ctx.$legend = $ctx.find('.js-label-overview__legend');
			ctx.$sideLegend = $ctx.find('.js-label-overview__legend--side');
			ctx.$headline = $ctx.find('.js-label-overview__headline');
			ctx.$link = $ctx.find('.js-label-overview__legend__link');
			ctx.hbsChartSource = $ctx.find('#o-label-overview__chart-template').html();
			ctx.hbsHeadlineSource = $ctx.find('#o-label-overview__headline-template').html();
			ctx.hbsLinkSource = $ctx.find('#o-label-overview__link-template').html();
			ctx.hbsChartTemplate = Handlebars.compile(ctx.hbsChartSource);
			ctx.hbsHeadlineTemplate = Handlebars.compile(ctx.hbsHeadlineSource);
			ctx.hbsLinkTemplate = Handlebars.compile(ctx.hbsLinkSource);
			ctx.type = null;
			ctx.year = null;
			ctx.period = null;

			ctx._events.on('green.chart.update', function (chartData) {
				if (doesNestedPropertyExist(chartData, 'data', 'overview', 'myLabelPercentages')) {
					var dataSet = {};

					// Series
					dataSet.series = chartData.data.overview.myLabelPercentages;
					$.each(dataSet.series, function (index, item) {
						item.name = item.label;
						item.value = parseFloat(item.percentage).toFixed(1);
						item.hexColor = window.chartist.colorMapping[item.id];
					});

					// Range
					if (chartData.range) {
						dataSet.range = chartData.range;
					}

					// Title
					if (doesNestedPropertyExist(chartData, 'labelOverview', 'donutChart', 'title')) {
						dataSet.title = chartData.labelOverview.donutChart.title;
					}

					// Headline
					if (doesNestedPropertyExist(chartData, 'labelOverview', 'headlineChart')) {
						dataSet.headlineChart = chartData.labelOverview.headlineChart;
					}

					// Link
					if (doesNestedPropertyExist(chartData, 'labelOverview', 'linkMoreTarget')) {
						dataSet.link = {};
						dataSet.link.link = chartData.labelOverview.link;
						dataSet.link.linkMoreText = chartData.labelOverview.linkMoreText;
						dataSet.link.linkMoreNewTab = chartData.labelOverview.linkMoreNewTab;
						dataSet.link.linkMoreTarget = chartData.labelOverview.linkMoreTarget;
					}

					// update legend an chart
					ctx.setLink(dataSet);
					ctx.setHeadline(dataSet);
					ctx.setLegend(dataSet);
					ctx.updateChart(dataSet);
				}
				else {
					// Should not happen. OPTIMISATION hide chart
				}
			});

			resolve();
		},
		// Generate legend lines
		setLegend: function (chartData) {
			var ctx = this,
				hbsData = {},
				hbsOutput = '',
				modifier = '',
				serie = null;

			ctx.$legend.empty();
			ctx.$sideLegend.empty();

			// Add date range legend
			if (chartData.range) {
				hbsOutput = ctx.hbsChartTemplate({
					'modifier': 'range',
					'decorator': '',
					'labels': {'legend': chartData.range}
				});
				ctx.$legend.append($(hbsOutput));
			}

			$.each(chartData.series, function (index, serie) {
				hbsData = {
					'modifier': 'label o-label-overview--label',
					'color': serie.hexColor,
					'decorator': '',
					'labels': {'legend': serie.name},
					'value': serie.value
				};
				hbsOutput = ctx.hbsChartTemplate(hbsData);
				ctx.$sideLegend.append($(hbsOutput));
			});

			// Show 2 columns for more than 8 labels
			if (chartData.series.length > 4) {
				ctx.$sideLegend.removeClass('o-label-overview__legend__alignment--onecol');
			}
			else {
				ctx.$sideLegend.addClass('o-label-overview__legend__alignment--onecol');
			}
		},
		setHeadline: function (data) {
			var ctx = this;
			var hbsOutput = ctx.hbsHeadlineTemplate(data.headlineChart);
			ctx.$headline.html($(hbsOutput));
		},
		setLink: function (data) {
			var ctx = this;
			var hbsOutput = ctx.hbsLinkTemplate(data.link);
			ctx.$link.html($(hbsOutput));
		},
		// Update chart with the new data set
		updateChart: function (data) {
			var ctx = this;

			data.labels = [];
			$.each(data.series, function (index, serie) {
				data.labels.push(serie.name);
			});

			ctx._events.emit('green.donutchart.udpate', data);
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * LabelYear module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class LabelYear
	 * @extends T.Module
	 */
	T.Module.LabelYear = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			// Initialize variables

			ctx.data = {};
			ctx.viewport = (ui && ui.Bootstrap && ui.Bootstrap.activeView) ? ui.Bootstrap.activeView : 'xs';
			ctx.visible = false;
			ctx.$legend = $ctx.find('.js-label-year__legend');
			ctx.$chart = $ctx.find('.js-label-year__chart');
			ctx.hbsSource = $ctx.find('#o-label-year__template').html();
			ctx.hbsTemplate = Handlebars.compile(ctx.hbsSource);
			ctx.year = null;
			ctx.label = null;
			ctx.text = null;

			$(window).on('resize', function () {
				ctx.handleChartVisibility();
			});

			ctx._events.on('green.chart.visibility', function (type) {
				ctx.visible = type === 'year';
				ctx.handleChartVisibility();
			});

			ctx._events.on('green.dropdown.select', function (key, value, focus, text) {
				// Update the chart
				if (key === 'label') {
					ctx.label = value;
					ctx.text = text;

					if (doesNestedPropertyExist(ctx.data, 'series', ctx.label)) {
						ctx.$chart.slideDown();
						ctx.setLegend();
						ctx.updateChart();
					} else {
						ctx.$chart.slideUp();
					}
				}
			});

			ctx._events.on('green.chart.update', function (chartData) {
				var structuredData = {};

				if (doesNestedPropertyExist(chartData, 'labelsData') && !jQuery.isEmptyObject(chartData.labelsData)) {
					// Set series
					structuredData.series = ctx.getStructuredSeriesData(chartData);

					// Range
					if (chartData.range) {
						structuredData.range = chartData.range;
					}

					ctx.data = structuredData;

					if (doesNestedPropertyExist(ctx.data, 'series', ctx.label)) {
						ctx.visible = true;
						ctx.handleChartVisibility();
						ctx.$chart.slideDown();
						ctx.setLegend();
						ctx.updateChart();
					} else {
						ctx.$chart.slideUp();
					}
				} else {
					ctx.visible = false;
					ctx.handleChartVisibility();
					// Should not happen. OPTIMISATION hide chart
				}
			});
			resolve();
		},
		// Generate legend lines
		setLegend: function () {
			var ctx = this,
				hbsData = {},
				hbsOutput = '',
				modifier = '',
				serie = null;

			ctx.$legend.empty();

			serie = ctx.data.series[ctx.label];

			if (serie) {
				// Add date range legend
				if (ctx.data.range) {
					hbsOutput = ctx.hbsTemplate({
						'modifier': 'range',
						'decorator': '',
						'labels': {'legend': ctx.data.range}
					});
					ctx.$legend.append($(hbsOutput));
				}

				hbsData = {
					'modifier': '',
					'color': serie.hexColor,
					'decorator': '',
					'labels': {'legend': serie.name + ' ' + ctx.text}
				};
				hbsOutput = ctx.hbsTemplate(hbsData);
				ctx.$legend.append($(hbsOutput));
			} else {
				// Should not happen. Only labels with data are selectable
			}
		},
		// Update chart with the new data set
		updateChart: function () {
			var ctx = this,
				labelData = ctx.data.series[ctx.label];

			if (labelData) {
				// Set data format
				var data = {
					labels: labelData.labels,
					series: [{'data': labelData.data, 'hexColor': labelData.hexColor}]
				};

				// Update bar chart
				ctx._events.emit('green.barchart.udpate', data);
			} else {
				ctx._events.emit('green.barchart.udpate', null);
				// Should not happen. Only labels with data are selectable. OPTIMISATION hide current chart
			}
		},
		// Handle visibility of the chart depending on the viewport and visibility settings
		handleChartVisibility: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			console.log('handleChartVisibility');

			ctx.viewport = (ui && ui.Bootstrap && ui.Bootstrap.activeView) ? ui.Bootstrap.activeView : ctx.viewport;

			if (ctx.viewport === 'sm' || ctx.viewport === 'md' || ctx.viewport === 'lg') {
				if (ctx.visible) {
					console.log('handleChartVisibility', 'slideDown');
					$ctx.slideDown();
				} else {
					console.log('handleChartVisibility', 'slideUp');
					$ctx.slideUp();
				}
			} else {
				$ctx.hide();
			}
		},
		getStructuredSeriesData: function (chartData) {
			var ctx = this,
				$ctx = $(this._ctx),
				structuredData = {};

			if (chartData.labelsData) {
				$.each(chartData.labelsData, function (labelId, labelData) {
					var name = '',
						serieData = {},
						tempData = [],
						percentages = [],
						labels = [],
						processedData = [],
						year = labelData[0]['id'].substr(0, 4),
						monthsMapping = chartData.data.overview.months;

					// Color
					serieData.color = labelId;
					serieData.hexColor = window.chartist.colorMapping[labelId];

					// Name
					if (doesNestedPropertyExist(chartData, 'labelYear', 'barChart', 'legendText')) {
						name = chartData.labelYear.barChart.legendText;
					}

					if (labelData && labelData.length > 0) {
						tempData = labelData.sort(function (a, b) {
							return a.id.localeCompare(b.id);
						});
					}

					$.each(tempData, function (index, object) {
						processedData[object.id] = {
							'percentage': parseFloat(object.percentage).toFixed(1),
							'label': object.label
						};
					});

					// sets percentages and labels
					// and fills month with no data
					ctx._fillMissingMonths(monthsMapping, year, processedData, percentages, labels);

					serieData.name = name;
					serieData.data = percentages;
					serieData.labels = labels;
					serieData.id = labelId;

					structuredData[labelId] = serieData;
				});
			}

			return structuredData;
		},
		// fills data of month with no data
		_fillMissingMonths: function (monthsMapping, year, processedData, percentages, labels) {
			// The year has to be the same for all entries
			var startId = year + '01',
				currentYear = new Date().getFullYear(),
				currentMonth = (new Date().getMonth()) + 1, // include the current month
				endId = year + (currentMonth < 10 ? '0' + currentMonth : currentMonth);

			if (year != currentYear) {
				endId = year + '12';
			}

			for (var count = startId; count <= endId; count++) {
				if (processedData[count]) {
					percentages.push(processedData[count]['percentage']);
					labels.push(processedData[count]['label']);
				} else {
					percentages.push(0);
					var tempMonth = count % 100; // get the two last digits
					labels.push(monthsMapping[tempMonth - 1]['shortName']);
				}
			}
		}

	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * TeaserComparison module implementation.
	 *
	 * @author Florian Gaechter <florian.gaechter@namics.com>
	 * @namespace T.Module
	 * @class TeaserComparison
	 * @extends T.Module
	 */
	T.Module.TeaserComparison = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			// Flag url mapping
			ctx.flagData = {
				'TG': {fileName: 'Wappen_Thurgau.svg'},
				'AR': {fileName: 'Wappen_Appenzell_AR.svg'},
				'AI': {fileName: 'Wappen_Appenzell_AI.svg'},
				'SG': {fileName: 'Wappen_St_Gallen.svg'},
				'GR': {fileName: 'Wappen_Graubuenden.svg'},
				'GL': {fileName: 'Wappen_Glarus.svg'},
				'ZG': {fileName: 'Wappen_Zug.svg'},
				'ZH': {fileName: 'Wappen_Zuerich.svg'},
				'SZ': {fileName: 'Wappen_Schwyz.svg'},
				'UR': {fileName: 'Wappen_Uri.svg'},
				'TI': {fileName: 'Wappen_Tessin.svg'},
				'NW': {fileName: 'Wappen_Nidwalden.svg'},
				'SH': {fileName: 'Wappen_Schaffhausen.svg'},
				'OW': {fileName: 'Wappen_Obwalden.svg'},
				'LU': {fileName: 'Wappen_Luzern.svg'},
				'AG': {fileName: 'Wappen_Aargau.svg'},
				'BL': {fileName: 'Wappen_Basel_Land.svg'},
				'BS': {fileName: 'Wappen_Basel_Stadt.svg'},
				'SO': {fileName: 'Wappen_Solothurn.svg'},
				'BE': {fileName: 'Wappen_Bern.svg'},
				'VS': {fileName: 'Wappen_Wallis.svg'},
				'JU': {fileName: 'Wappen_Jura.svg'},
				'NE': {fileName: 'Wappen_Neuenburg.svg'},
				'FR': {fileName: 'Wappen_Freiburg.svg'},
				'VD': {fileName: 'Wappen_Waadt.svg'},
				'GE': {fileName: 'Wappen_Genf.svg'}
			};

			ctx.images = {
				filePath: $ctx.data('flag-path') || '/img/svg/flag/',
				swiss: $ctx.data('swiss-image') || '/img/bg/switzerland.svg',
				my: $ctx.data('my-image') || '/img/bg/basket.png'
			};

			ctx.hbsTeaserSource = $($ctx.data('tpl-teaser')).html();
			ctx.hbsTeaserTemplate = Handlebars.compile(ctx.hbsTeaserSource);

			ctx.hbsRangeSource = $($ctx.data('tpl-range')).html();
			ctx.hbsRangeTemplate = Handlebars.compile(ctx.hbsRangeSource);

			ctx.$myTeaser = $ctx.find('.js-teaser-comparison__personalized');
			ctx.$cantonTeaser = $ctx.find('.js-teaser-comparison__canton');
			ctx.$swissTeaser = $ctx.find('.js-teaser-comparison__swiss');
			ctx.$rangeContainer = $ctx.find('.js-teaser-comparison__range');

			ctx._events.on('green.chart.update', function (chartData) {
				if (doesNestedPropertyExist(chartData, 'teaserComparison')) {

					// MyTeaser
					if (doesNestedPropertyExist(chartData.teaserComparison, 'teaserStatsComparisonPersonalized')) {
						var data = chartData.teaserComparison.teaserStatsComparisonPersonalized;
						data.imageUrl = ctx.images.my;
						ctx._renderTeaser(ctx.$myTeaser, chartData.teaserComparison.teaserStatsComparisonPersonalized);
					}

					// CantonTeaser
					if (doesNestedPropertyExist(chartData.teaserComparison, 'teaserStatsComparisonCanton')) {
						var data = chartData.teaserComparison.teaserStatsComparisonCanton;

						// Get the canton flag
						if (data.region) {
							var flag = ctx.flagData[data.region];
							data.imageUrl = ctx.images.filePath + flag.fileName;
						}
						ctx._renderTeaser(ctx.$cantonTeaser, data);
					}

					// SwissTeaser
					if (doesNestedPropertyExist(chartData.teaserComparison, 'teaserStatsComparisonSwitzerland')) {
						var data = chartData.teaserComparison.teaserStatsComparisonSwitzerland;
						data.imageUrl = ctx.images.swiss;
						ctx._renderTeaser(ctx.$swissTeaser, chartData.teaserComparison.teaserStatsComparisonSwitzerland);
					}

					// Range legend
					if (chartData.range) {
						ctx._renderRange(chartData.range);
					}
				}
				else {
					// Should not happen
				}
			});

			resolve();
		},
		_renderTeaser: function ($container, data) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			$container.html(ctx.hbsTeaserTemplate(data));
		}

		,
		_renderRange: function (text) {
			var ctx = this,
				$ctx = $(ctx._ctx),
				data = {
					'modifier': 'range',
					'decorator': '',
					'labels': {'legend': text}
				};

			ctx.$rangeContainer.html(ctx.hbsRangeTemplate(data));
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * TeaserStatus module implementation.
	 *
	 * @author Florian Gaechter <florian.gaechter@namics.com>
	 * @namespace T.Module
	 * @class TeaserStatus
	 * @extends T.Module
	 */
	T.Module.TeaserStatus = T.createModule({
		start: function(resolve) {
			var ctx = this,
				$ctx = $(this._ctx),
				errorText = $ctx.data('error-msg') || 'Error';

			ctx.ajax = {
				_reqParameter: $ctx.data('req-parameter') || {},
				_api: $ctx.data('api-url') || '',
				_datatype: 'json',
				_timeout: $ctx.data('api-timeout') || 7000
			};

			ctx.hbsLoginSource = $($ctx.data('tpl-login')).html();
			ctx.hbsLoginTemplate = Handlebars.compile(ctx.hbsLoginSource);

			ctx.hbsStatsSource = $($ctx.data('tpl-stats')).html();
			ctx.hbsStatsTemplate = Handlebars.compile(ctx.hbsStatsSource);

			ctx.hbsErrorSource = $($ctx.data('tpl-error')).html();
			ctx.hbsErrorTemplate = Handlebars.compile(ctx.hbsErrorSource);

			ctx.$container = $ctx.find('.js-teaser-status__content');

			ctx.$loadingWrapper = $('.js-teaser-status__loading-sign', $ctx);

			ctx.images = {
				my: $ctx.data('my-image') || '/img/bg/basket.png'
			};

			$.ajax({
					url: ctx.ajax._api,
					type: 'GET',
					data: ctx.ajax._reqParameter,
					dataType: ctx.ajax._datatype,
					timeout: ctx.ajax._timeout,
					contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
				})
				.done(function(data) {
					if (doesNestedPropertyExist(data, 'teaserStatus', 'teaserStats')) {
						var statsData = data.teaserStatus.teaserStats;
						statsData.imageUrl = ctx.images.my;
						ctx._successHandler(ctx.hbsStatsTemplate, statsData);
					}
					else if (doesNestedPropertyExist(data, 'teaserStatus', 'teaserLoginSignup')) {
						ctx._successHandler(ctx.hbsLoginTemplate, data.teaserStatus.teaserLoginSignup);
                        // Apply migros bootstrap form logic to the newly loaded component
                        $(ui.bootstrapFormBusinessLogicComponent());
                        $(ui.bootstrapCumulusConnectComponent());
                        $(ui.bootstrapFormValidationView('.ui-js-form'));
                        $(ui.bootstrapPopOverComponent());
					}
					else if (doesNestedPropertyExist(data, 'teaserStatus', 'teaserLogin')) {
						// CUM-1104 Don't reload template because login is already rendered initially and after the
						// reload JS is not invoked on the login button.
						if (typeof mui !== 'undefined' && typeof mui.LoginView === 'function') {
							$('.mui-js-login').muiLogin();
						}
					}
					else if (doesNestedPropertyExist(data, 'errorMessage')) {
						ctx._errorHandler(data);
					}
					else {
						// 200 with no data is interpreted as error
						ctx._errorHandler({'errorMessage': errorText});
					}
					ctx.$loadingWrapper.addClass('o-teaser-status__loading-sign--hidden');
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					if (jqXHR.responseJSON && jqXHR.responseJSON.errorMessage) {
						ctx._errorHandler(jqXHR.responseJSON);
					}
					else {
						ctx._errorHandler({'errorMessage': errorText});
					}
					ctx.$loadingWrapper.addClass('o-teaser-status__loading-sign--hidden');
				});

            // Load migros bootstrap form logic initially
            $(ui.bootstrapFormBusinessLogicComponent());
            $(ui.bootstrapCumulusConnectComponent());
            $(ui.bootstrapFormValidationView('.ui-js-form'));
            $(ui.bootstrapPopOverComponent());

			resolve();
		},
		_successHandler: function(template, data) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			ctx.$container.html(template(data));
			ctx._sandbox.addModules(ctx.$container.get(0));
		},
		_errorHandler: function(data) {
			var ctx = this,
				$ctx = $(ctx._ctx);

			ctx.$container.html(ctx.hbsErrorTemplate(data));
			ctx._sandbox.addModules(ctx.$container.get(0));
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * YearTrend module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class YearTrend
	 * @extends T.Module
	 */
	T.Module.YearTrend = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			// Initialize variables

			ctx.viewport = (ui && ui.Bootstrap && ui.Bootstrap.activeView) ? ui.Bootstrap.activeView : 'xs';
			ctx.visible = false;
			ctx.$legend = $ctx.find('.js-year-trend__legend');
			ctx.hbsSource = $ctx.find('#o-year-trend__template').html();
			ctx.hbsTemplate = Handlebars.compile(ctx.hbsSource);
			ctx.const = {
				MY: 'mydata',
				SWISS: 'swissdata',
				REFERENCE: 'referencedata'
			};

			// Event handlers

			$(window).on('resize', function () {
				ctx.handleChartVisibility();
			});

			ctx._events.on('green.chart.visibility', function (type) {
				ctx.visible = type === 'year';
				ctx.handleChartVisibility();
			});

			ctx._events.on('green.chart.update', function (chartData) {
				var structuredData = {};

				if (doesNestedPropertyExist(chartData, 'data', 'overview', 'annualDevelopment')) {
					structuredData = {
						'series': [],
						'labels': []
					};

					// Labels
					structuredData.labels = ctx.getStructuredLabelsData(chartData.data.overview.annualDevelopment);

					if (doesNestedPropertyExist(chartData.data, 'annualDevelopment')) {
						// Swiss data (is in data.annualDevelopment)
						structuredData.series.push(ctx.getStructuredSeriesData(chartData, ctx.const.SWISS));
						// My data (is in data.overview.annualDevelopment)
						structuredData.series.push(ctx.getStructuredSeriesData(chartData, ctx.const.MY));
					} else {
						// Swiss data (is in data.overview.annualDevelopment)
						structuredData.series.push(ctx.getStructuredSeriesData(chartData, ctx.const.SWISS));
					}

					// Reference value
					if (doesNestedPropertyExist(chartData.data.overview, 'goals') && doesNestedPropertyExist(chartData, 'yearTrend', 'lineChart', 'year') && chartData.data.overview.goals[chartData.yearTrend.lineChart.year]) {
						structuredData.series.push(ctx.getStructuredSeriesData(chartData, ctx.const.REFERENCE));
					}

					// Range legend
					if (chartData.range) {
						structuredData.range = chartData.range;
					}
				}

				if (!$.isEmptyObject(structuredData)) {
					// update legend an chart
					ctx.setLegend(structuredData);
					ctx.updateChart(structuredData);
				}
				else {
					// Should not happen. OPTIMISATION hide chart
				}
			});

			resolve();
		},
		// Generate legend lines
		setLegend: function (data) {
			var ctx = this,
				hbsData = {},
				hbsOutput = '',
				modifier = '';

			ctx.$legend.empty();

			if (data.range) {
				hbsOutput = ctx.hbsTemplate({
					'modifier': 'range',
					'decorator': '',
					'labels': {'legend': data.range}
				});
				ctx.$legend.append($(hbsOutput));
			}

			$.each(data.series, function (index, serie) {
				modifier = serie.type || '';
				if (modifier) {
					hbsData = {
						'modifier': modifier,
						'color': '',
						'decorator': '',
						'labels': {'legend': serie.name}
					};
				}
				else {
					hbsData = {
						'modifier': modifier,
						'color': window.chartist.colorMapping[serie.color],
						'decorator': '',
						'labels': {'legend': serie.name}
					};
				}
				hbsOutput = ctx.hbsTemplate(hbsData);
				ctx.$legend.append($(hbsOutput));
			});
		},
		// Update chart with the new data set
		updateChart: function (data) {
			this._events.emit('green.linechart.udpate', data);
		},
		// Handle visibility of the chart depending on the viewport and visibility settings
		handleChartVisibility: function () {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.viewport = (ui && ui.Bootstrap && ui.Bootstrap.activeView) ? ui.Bootstrap.activeView : ctx.viewport;

			if (ctx.viewport === 'sm' || ctx.viewport === 'md' || ctx.viewport === 'lg') {
				if (ctx.visible) {
					$ctx.slideDown();
				}
				else {
					$ctx.slideUp();
				}
			}
			else {
				$ctx.hide();
			}
		},
		// Get structured data out of "raw" data from the api
		getStructuredLabelsData: function (chartData) {
			var ctx = this,
				$ctx = $(this._ctx),
				labels = [],
				tempData = [];

			tempData = chartData.sort(function (a, b) {
				return a.id.localeCompare(b.id);
			});

			$.each(tempData, function (index, object) {
				labels.push(object.label);
			});

			return labels;
		},
		// Get structured data out of "raw" data from the api
		getStructuredSeriesData: function (chartData, type) {
			var ctx = this,
				$ctx = $(this._ctx),
				structuredData = {},
				name = '',
				tempData = [],
				percentages = [],
				rawData = null;


			switch (type) {
				case ctx.const.REFERENCE:
					// Data: Set goal value n times for each month
					var goal = parseFloat(chartData.data.overview.goals[chartData.yearTrend.lineChart.year]).toFixed(1),
						i = 0;
					while (i <= chartData.data.overview.annualDevelopment.length) {
						percentages.push(goal);
						i++;
					}
					// Type
					structuredData.type = 'reference';
					// Name
					if (doesNestedPropertyExist(chartData, 'yearTrend', 'lineChart', 'goalLegend')) {
						name = chartData.yearTrend.lineChart.goalLegend;
					}
					break;
				case ctx.const.MY:
					// Data
					rawData = chartData.data.overview.annualDevelopment;
					// Color
					structuredData.color = 'myColor';
					structuredData.hexColor = window.chartist.colorMapping.myColor;
					// Name
					if (doesNestedPropertyExist(chartData, 'yearTrend', 'lineChart', 'myLegend')) {
						name = chartData.yearTrend.lineChart.myLegend;
					}
					break;
				case ctx.const.SWISS:
				default:
					// Data ('my data' exists if `chartData.data.annualDevelopment` is set. In this case the swiss data is placed in data.overview.)
					rawData = doesNestedPropertyExist(chartData, 'data', 'annualDevelopment') ? chartData.data.annualDevelopment : chartData.data.overview.annualDevelopment;
					// Color
					structuredData.color = 'swissColor';
					structuredData.hexColor = window.chartist.colorMapping.swissColor;
					// Name
					if (doesNestedPropertyExist(chartData, 'yearTrend', 'lineChart', 'swissLegend')) {
						name = chartData.yearTrend.lineChart.swissLegend;
					}
			}

			if (type === ctx.const.MY || type === ctx.const.SWISS) {
				tempData = rawData.sort(function (a, b) {
					return a.id.localeCompare(b.id);
				});

				$.each(tempData, function (index, object) {
					percentages.push(parseFloat(object.percentage).toFixed(1));
				});
			}

			// Fill series data
			structuredData.name = name;
			structuredData.data = percentages;

			return structuredData;
		}
	});
}(jQuery));

(function ($) {
	'use strict';
	/**
	 * Charts module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class Charts
	 * @extends T.Module
	 */
	T.Module.Charts = T.createModule({
		start: function (resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.ajax = {
				_reqParameter: $ctx.data('req-parameter') || {},
				_api: $ctx.data('api-url') || '',
				_yearPeriodUrl: 'year/',
				_periodPeriodUrl: 'period/',
				_datatype: 'json',
				_timeout: $ctx.data('api-timeout') || 7000
			};
			ctx.data = {};
			ctx.data.latestLabel = ''; // prevent undefined exception
			ctx.data.isLoadingData = false;
			ctx.loadedUrls = [];

			ctx.$loadingWrapper = $('.js-charts__loading__loading-sign', $ctx);
			ctx.$contentWrapper = $('.js-charts__content', $ctx);
			ctx.$errorWrapper = $('.js-charts__error', $ctx);
			ctx.$errorNoDataWrapper = $('.js-charts__nodata-error', $ctx);

			/**
			 * Handle selection of a children dropdown
			 * type: period type [year|period]
			 * period: period value
			 */
			this._events.on('green.chart.reload', function (type, period) {
				var periodLength = (period + '').length,
					didChange = type !== ctx.data.latestType || period !== ctx.data.latestPeriod,
					isValid = (type === 'year' && periodLength === 4) || (type === 'period' && periodLength > 4);

				if (!ctx.data[type]) {
					ctx.data[type] = {};
				}

				ctx.data.latestType = type;
				ctx.data.latestPeriod = period;

				if (ctx.data[type] && !ctx.data[type][period]) {
					// show loading overlay
					ctx.$loadingWrapper.removeClass('template-charts__loading__loading-sign--hidden');
					ctx.data.isLoadingData = true;
					// load data
					ctx.loadDataForPeriod(type, period, function (data) {
						// SUCESS
						if (data.charts && type === ctx.data.latestType && period === ctx.data.latestPeriod) {
							ctx._hideError();
							ctx._events.emit('green.chart.visibility', type);
							ctx._events.emit('green.chart.update', data.charts);
							if (isValid) {
								ctx._trackStatistics(type, period);
							}
						} else {
							ctx._showError();
							ctx._events.emit('green.chart.visibility', type);
							// hide loading overlay
							ctx.$loadingWrapper.addClass('template-charts__loading__loading-sign--hidden');
						}
						// hide loading overlay
						ctx.$loadingWrapper.addClass('template-charts__loading__loading-sign--hidden');
						ctx.data.isLoadingData = false;
					}, function (jqxhr, textStatus, text) {
						// ERROR
						ctx._showError();
						ctx._events.emit('green.chart.visibility', type);
						// hide loading overlay
						ctx.$loadingWrapper.addClass('template-charts__loading__loading-sign--hidden');
						ctx.data.isLoadingData = false;
					});
				} else {
					ctx._events.emit('green.chart.visibility', type);
					if (didChange && isValid) {
						ctx._trackStatistics(type, period);
					}

					if (ctx.data[type][period].charts) {
						ctx._hideError();
						ctx._events.emit('green.chart.update', ctx.data[type][period].charts);
					} else {
						ctx._showError();
					}
				}
			});

			// track label select changes
			this._events.on('green.labelselect.change', function (trackingLabels, values) {
				var isYear = values.type && values.type === 'year',
					isYearSet = values.year,
					hasYearChanged = values.year !== ctx.data.latestPeriod,
					hasLabels = Object.keys(trackingLabels)[0],
					hasLabelChanged = ctx.data.latestLabel && values.label !== ctx.data.latestLabel;

				// Ignore case at initial rendering (before ajax request)
				// Loading-data-check prevents from tracking changes of the label during loading (a regular side effect)
				if (isYear && isYearSet && !hasYearChanged && hasLabels && hasLabelChanged && !ctx.data.isLoadingData) {
					var trackingData = {
						event: 'cumulusGreenImpression',
						periodType: 'jahr', // labelselect only exists if type is 'year'
						period: ctx.data.latestPeriod + '',
						label: values.label + '',
						cumulusGreenValue: ctx.data.trackingGreenValue + '',
						labels: trackingLabels
					};

					ctx.data.latestLabel = values.label;
					ctx._track(trackingData);
				}
			});


			resolve();
		},
		// Load data set for provided period. On success reset the legend and update the chart.
		loadDataForPeriod: function (type, period, successCallback, errorCallback) {
			var ctx = this,
				urlPrefix = '',
				dataKey = ctx[ctx.type];

			if (!type || !period || !ctx.ajax._api) {
				return false;
			}

			if (type === 'year') {
				urlPrefix = ctx.ajax._yearPeriodUrl;
			} else if (type === 'period') {
				urlPrefix = ctx.ajax._periodPeriodUrl;
			} else {
				// Should never happen
			}

			var url = urlPrefix + period + '.json';

			// Prevent multiple ajax requests fore the same url
			if (ctx.loadedUrls.indexOf(url) < 0) {
				ctx.loadedUrls.push(url);

				$.ajax({
					url: ctx.ajax._api + url,
					type: 'GET',
					data: ctx.ajax._reqParameter,
					dataType: ctx.ajax._datatype,
					timeout: ctx.ajax._timeout,
					contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
				})
					.done(function (data) {
						if (data) {
							// MRT-2025 labelsData check to handle year with no data
							if (!doesNestedPropertyExist(data.charts, 'labelsData') || (doesNestedPropertyExist(data.charts, 'labelsData') && !$.isEmptyObject(data.charts.labelsData))) {
								ctx.data[type][period] = data;
								successCallback(data);
							} else {
								ctx._showNoDataError();
								ctx._events.emit('green.chart.visibility', type);
								ctx._spliceElement(ctx.loadedUrls, url);
								// hide loading overlay
								ctx.$loadingWrapper.addClass('template-charts__loading__loading-sign--hidden');
								ctx.data.isLoadingData = false;
							}
						} else {
							errorCallback();
							// Remove url to enable reloading
							ctx._spliceElement(ctx.loadedUrls, url);
						}
					})
					.fail(function (jqxhr, textStatus, errorThrown) {
						// Remove url to enable reloading
						ctx._spliceElement(ctx.loadedUrls, url);
						errorCallback(jqxhr, textStatus, errorThrown);
					});
			} else {
				// do nothing, an equal request is concurrently in progress
			}
		},
		// Splice an elment from an array
		_spliceElement: function (array, element) {
			var index = array.indexOf(element);
			if (index > -1) {
				array.splice(index, 1);
			}
		},
		// show error message
		_showError: function () {
			var ctx = this;

			ctx.$contentWrapper.hide();
			ctx.$errorWrapper.fadeIn();
		},
		// show no data error message
		_showNoDataError: function () {
			var ctx = this;

			ctx.$contentWrapper.hide();
			ctx.$errorNoDataWrapper.fadeIn();
		},
		// hide error message and show content
		_hideError: function () {
			var ctx = this;

			ctx.$contentWrapper.fadeIn();
			ctx.$errorWrapper.hide();
			ctx.$errorNoDataWrapper.hide();
		},
		// GTM tracking
		_trackStatistics: function (type, period) {
			var ctx = this,
				$ctx = $(this._ctx),
				chartData = ctx.data[type][period],
				trackingGreenValue = '',
				trackingLabels = {};

			// GTM: The period and public view is tracked here. The year view is tracked in labelselect.js.
			// Public view
			if ($ctx.hasClass('js-t-charts--public')) {
				ctx._track({
					event: 'cumulusGreenImpression',
					periodType: type === 'year' ? 'jahr' : 'sammel_periode',
					period: period + '',
					label: '',
					cumulusGreenValue: '',
					labels: {}
				});
			}
			// Period ('sammel_periode') selection
			else if (type === 'period') {
				if (doesNestedPropertyExist(chartData, 'charts', 'teaserComparison', 'teaserStatsComparisonPersonalized', 'percentage')) {
					ctx.data.trackingGreenValue = chartData.charts.teaserComparison.teaserStatsComparisonPersonalized.percentage + '%';
				}

				if (doesNestedPropertyExist(chartData, 'charts', 'data', 'overview', 'myLabelPercentages')) {
					$.each(chartData.charts.data.overview.myLabelPercentages, function (index, value) {
						trackingLabels[value.label] = parseFloat(value.percentage).toFixed(1) + '%';
					});
				}

				ctx._track({
					event: 'cumulusGreenImpression',
					periodType: 'sammel_periode',
					period: period + '',
					label: '',
					cumulusGreenValue: ctx.data.trackingGreenValue + '',
					labels: trackingLabels
				});
			}
				// Period ('jahr') selection
				// This case occurs only after selecting the type year or a period for the year.
			// Label changes are tracked with the eventhandler for `green.labelselect.change`
			else if (type === 'year') {
				var options = [],
					trackingData = {};

				if (doesNestedPropertyExist(chartData, 'charts', 'teaserComparison', 'teaserStatsComparisonPersonalized', 'percentage')) {
					ctx.data.trackingGreenValue = chartData.charts.teaserComparison.teaserStatsComparisonPersonalized.percentage + '%';
				}

				if (doesNestedPropertyExist(chartData, 'charts', 'data', 'overview', 'myLabelPercentages')) {
					$.each(chartData.charts.data.overview.myLabelPercentages, function (index, value) {
						if (index === 0) {
							ctx.data.latestLabel = value.id;
						}
						trackingLabels[value.label] = parseFloat(value.percentage).toFixed(1) + '%';
					});
				}

				ctx._track({
					event: 'cumulusGreenImpression',
					periodType: 'jahr',
					period: period + '',
					label: ctx.data.latestLabel + '',
					cumulusGreenValue: ctx.data.trackingGreenValue + '',
					labels: trackingLabels
				});
			}
		},
		// client tracking
		_track: function (data) {
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push(data);
			} else {
				if (typeof window.console !== 'undefined') {
					window.console.log(data);
				}
			}
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * Dashboard module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class Dashboard
	 * @extends T.Module
	 */
	T.Module.Dashboard = T.createModule({
		start: function(resolve) {
			var $ctx = $(this._ctx);

			resolve();
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * goal module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class Goal
	 * @extends T.Module
	 */
	T.Module.Goal = T.createModule({
		start: function(resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.timeoutHandler = null;

			// Form submit validation

			$ctx.on('click', '.js-goal__submit', function(e) {
				var value = ctx._preprocessGoalString();

				if (!ctx._validateGoalString(value)) {
					e.preventDefault();
					ctx._showValidationInformation();
				}
			});

			$ctx.on('submit', '.js-goal__form', function() {
				var value = ctx._preprocessGoalString();

				if (ctx._validateGoalString(value)) {
					ctx._track({
						event: 'greenGoalChange',
						cumulusGreenChange: $ctx.find('.js-goal__submit').hasClass('js-goal__submit--set') ? 'aendern' : 'setzen',
						cumulusGreenValue: value
					});
					return true;
				}
				else {
					ctx._showValidationInformation();
					return false;
				}
			});

			// Facebook handling
			ctx.$facebook = $ctx.find('.js-goal__button-wrapper__facebook');
			if (ctx.$facebook.length > 0) {
				ctx._setFbShareLink();
				$ctx.on('click', '.js-goal__button-wrapper__facebook', function() {
					ctx._track({
						event: 'socialInteraction',
						socialNetwork: 'Facebook',
						socialAction: 'Share',
						cumulusGreenValue: ctx.$facebook.data('target-percentage')
					});
				});
			}

			// Handle input change once and remove facebook button
			$ctx.on('keyup.green.change-watcher', '.js-goal-input', function() {
				if ($(this).val() !== $(this).data('set-value')) {
					ctx.$facebook.hide();
					$ctx.find('.js-goal__submit').removeClass('goal__button-wrapper__submit--hidden');
					$ctx.off('keyup.green.change-watcher');
				}
			});

			ctx._track({
				event: 'cumulusGreenGoal',
				cumulusGreenValue: $ctx.find('.js-goal-input').val()
			});

			resolve();
		},
		// Set '%' at the end of string and remove a trailing '.'
		_preprocessGoalString: function() {
			var ctx = this,
				$ctx = $(this._ctx),
				value = $ctx.find('.js-goal-input').val();

			value = value.replace(/%/, '') + '%';
			value = value.replace(/\.%/, '%');

			$ctx.find('.js-goal-input').val(value);
			return value;
		},
		// Validate the goal string
		_validateGoalString: function(goalString) {
			return /^(100|[0-9]{1,2}(\.[0-9]?)?)\%$/.test(goalString);
		},
		// Show information at pressing invalid key
		_showValidationInformation: function() {
			var ctx = this,
				$ctx = $(this._ctx),
				$inputField = $ctx.find('.js-goal-input'),
				$validationText = $ctx.find('.js-goal__validation-information');

			window.clearTimeout(ctx.timeoutHandler);

			$inputField.addClass('state-error');
			$validationText.addClass('state-error');
			$validationText.slideDown();
			ctx.timeoutHandler = window.setTimeout(function() {
				$inputField.removeClass('state-error');
				$validationText.removeClass('state-error');
				$validationText.slideUp();
			}, 2500);
		},
		_setFbShareLink: function() {
			var ctx = this,
				$ctx = $(this._ctx),
				data = {
					appId: '481437678546818',
					url: 'https://www.facebook.com/dialog/feed?',
					link: ctx.$facebook.data('link'),
					name: ctx.$facebook.data('name'),
					picture: ctx.$facebook.data('picture'),
					caption: ' ',
					description: ctx.$facebook.data('description'),
					redirectUri: ctx.$facebook.data('redirect-uri'),
					display: 'popup'
				},
				shareURL = data.url + 'app_id=' + data.appId + '&link=' + data.link + '&picture=' + data.picture + '&name=' + data.name + '&caption=' + data.caption + '&description=' + data.description + '&redirect_uri=' + data.redirectUri + '&display=' + data.display;

			ctx.$facebook.attr({'href': encodeURI(shareURL), 'target': '_blank'});
		},
		// client tracking
		_track: function(data) {
			if (typeof window.dataLayer !== 'undefined') {
				window.dataLayer.push(data);
			}
			else {
				if (typeof window.console !== 'undefined') {
					window.console.log(data);
				}
			}
		}
	});
}(jQuery));

(function($) {
	'use strict';
	/**
	 * YearTeaser module implementation.
	 *
	 * @author Beat Gebistorf <beat.gebistorf@namics.com>
	 * @namespace T.Module
	 * @class YearTeaser
	 * @extends T.Module
	 */
	T.Module.YearTeaser = T.createModule({
		start: function(resolve) {
			var ctx = this,
				$ctx = $(this._ctx);

			ctx.ajax = {
				_reqParameter: $ctx.data('req-parameter') || {},
				_api: $ctx.data('api-url') || '',
				_datatype: 'json',
				_timeout: $ctx.data('api-timeout') || 7000
			};

			ctx.hbsSource = $($ctx.data('tpl')).html();
			ctx.hbsTemplate = Handlebars.compile(ctx.hbsSource);

			ctx.$container = $ctx.find('.js-year-teaser__content');

			ctx.$loadingWrapper = $('.js-year-teaser__loading-sign', $ctx);

			$.ajax({
				url: ctx.ajax._api,
				type: 'GET',
				data: ctx.ajax._reqParameter,
				dataType: ctx.ajax._datatype,
				timeout: ctx.ajax._timeout,
				contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
			})
				.done(function (data) {
					if (doesNestedPropertyExist(data, 'yearTeaser', 'teaserPersonalized')) {
						ctx._successHandler(ctx.hbsTemplate, data.yearTeaser.teaserPersonalized);
					}
					else {
						ctx._errorHandler();
					}
					ctx.$loadingWrapper.addClass('template-year-teaser__loading-sign--hidden');
				})
				.fail(function (jqxhr, textStatus, errorThrown) {
					ctx.$loadingWrapper.addClass('template-year-teaser__loading-sign--hidden');
					// Failed request results in showing the initially rendered status
				});

			resolve();
		},
		_successHandler: function(template, data){
			var ctx = this,
				$ctx = $(ctx._ctx);

			ctx.$container.html(template(data));
			ctx._sandbox.addModules(ctx.$container.get(0));
		},
		_errorHandler: function(){
			// Should never happen
		}
	});
}(jQuery));
